import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.iidx');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const YOUTUBE_SEARCH_URL = 'https://www.youtube.com/results';
const DEFAULT_TIERS = ['S+', 'S', 'A+', 'A', 'B+', 'B', 'C', 'D', 'E', 'F', '미분류'];
const CLASSIFICATION_SECTIONS: any[] = [
    { value: 'ep', label: '지력' },
    { value: 'id', label: '개인차' }
];
const THEME_STORAGE_KEY = 'taigo_theme_mode';
const UPDATE_POLL_INTERVAL_MS = 5000;
const UPDATE_POLL_TIMEOUT_MS = 10 * 60 * 1000;
const IIDX_EAGATE_STATUS_URL = 'https://p.eagate.573.jp/game/2dx/33/djdata/status.html';
const IIDX_EAGATE_WINDOW_NAME = 'taigo_iidx_eamusement_update';
const IIDX_EAGATE_WINDOW_FEATURES = 'popup,width=520,height=760,left=80,top=60,resizable=yes,scrollbars=yes';
const IIDX_LOCAL_SCORE_STORAGE_KEY = 'iidx_local_scores';
const IIDX_DAN_LAMP_WEIGHT = 0.82;
const IIDX_DAN_SCORE_WEIGHT = 0.18;
type ThemeMode = 'dark' | 'light';
type PlayStyle = 'SP' | 'DP';
type SortMode = 'default' | 'clear' | 'score';
type TableTab = { value: string; label: string; accent?: string };
type IidxTableMode = 'tier' | 'dan';
declare const WizRoute: any;
const IIDX_LAMP_PROGRESS_ITEMS: any[] = [
    { key: 'no-play', label: '미플레이', color: '#52525b' },
    { key: 'failed', label: 'FAILED', color: '#f87171' },
    { key: 'assist', label: 'ASSIST', color: '#c084fc' },
    { key: 'easy', label: 'EASY', color: '#bef264' },
    { key: 'normal', label: 'CLEAR', color: '#2563eb' },
    { key: 'hard', label: 'HARD', color: '#ffffff' },
    { key: 'ex-hard', label: 'EXH', color: '#fde047' },
    { key: 'full-combo', label: 'FC', color: '#7dd3fc' }
];
const IIDX_SCORE_PROGRESS_ITEMS: any[] = [
    { key: 'none', label: '점수 없음', color: '#52525b' },
    { key: 'F', label: 'F', color: '#71717a' },
    { key: 'E', label: 'E', color: '#78716c' },
    { key: 'D', label: 'D', color: '#a16207' },
    { key: 'C', label: 'C', color: '#0f766e' },
    { key: 'B', label: 'B', color: '#2563eb' },
    { key: 'A', label: 'A', color: '#7c3aed' },
    { key: 'AA', label: 'AA', color: '#db2777' },
    { key: 'AAA', label: 'AAA', color: '#f59e0b' },
    { key: 'MAX', label: 'MAX', color: '#22d3ee' },
    { key: 'scored', label: '기록 있음', color: '#0e7490' }
];
const IIDX_CLEAR_TYPE_OPTIONS: any[] = [
    { value: 'NO PLAY', label: '미플레이' },
    { value: 'FAILED', label: 'FAILED' },
    { value: 'A-CLEAR', label: 'ASSIST' },
    { value: 'E-CLEAR', label: 'EASY' },
    { value: 'CLEAR', label: 'CLEAR' },
    { value: 'H-CLEAR', label: 'HARD' },
    { value: 'EXH-CLEAR', label: 'EX HARD' },
    { value: 'F-COMBO', label: 'FULL COMBO' }
];

@Component({
    selector: 'wiz-page-iidx',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.iidx/view.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100%;
}

.iidx-root {
  min-height: 100vh;
  background: #f4f4f5;
  color: #18181b;
}

.iidx-wrap {
  width: min(100%, 1120px);
  margin: 0 auto;
  padding: 0 10px;
}

.iidx-header {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid #d4d4d8;
  background: rgba(250, 250, 250, 0.96);
}

.iidx-header-inner {
  padding-top: 6px;
  padding-bottom: 7px;
}

.iidx-title-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.iidx-title-block {
  min-width: 0;
}

.iidx-title-block h1 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
}

.iidx-nav {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
  font-size: 12px;
}

.iidx-theme-toggle {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #3f3f46;
  padding: 0;
  transition: border-color 0.18s ease, background-color 0.18s ease, color 0.18s ease;
}

.iidx-theme-toggle:hover {
  border-color: #0891b2;
  color: #0e7490;
}

.iidx-theme-toggle svg {
  width: 15px;
  height: 15px;
}

.iidx-nav a {
  color: #52525b;
  text-decoration: none;
}

.iidx-nav a:hover {
  color: #18181b;
}

.iidx-play-link {
  display: inline-flex;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #52525b;
  padding: 0 9px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
}

.iidx-play-link:hover {
  color: #18181b;
}

.iidx-play-link.is-active {
  border-color: #155e75;
  background: #164e63;
  color: #ecfeff;
}

.iidx-update-open {
  display: inline-flex;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #52525b;
  padding: 0 9px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.iidx-update-open:hover {
  border-color: #155e75;
  color: #0e7490;
}

.iidx-export-open {
  gap: 4px;
}

.iidx-export-open svg {
  width: 13px;
  height: 13px;
}

.iidx-export-open:disabled {
  color: #a1a1aa;
  cursor: wait;
}

.iidx-export-spinner {
  width: 12px;
  height: 12px;
  border: 2px solid #d4d4d8;
  border-top-color: #155e75;
  border-radius: 999px;
  animation: iidx-spin 0.8s linear infinite;
}

.iidx-controls {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  margin-top: 6px;
}

.iidx-tier-tab,
.iidx-clear {
  height: 30px;
  border: 0;
  background: transparent;
  color: #52525b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.iidx-tier-tabs {
  display: flex;
  gap: 4px;
  min-width: 0;
  overflow-x: auto;
  padding-bottom: 1px;
}

.iidx-tier-tab {
  flex: 0 0 auto;
  min-width: 42px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  padding: 0 10px;
}

.iidx-tier-tab.is-active {
  border-width: 2px;
  color: #18181b;
}

.iidx-dan-tab {
  margin-left: 6px;
}

.iidx-dan-panel {
  overflow: hidden;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #ffffff;
}

.iidx-dan-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid #e4e4e7;
}

.iidx-dan-head h2 {
  margin: 0;
  color: #18181b;
  font-size: 16px;
  font-weight: 800;
}

.iidx-dan-head p {
  margin: 4px 0 0;
  color: #71717a;
  font-size: 12px;
  line-height: 1.4;
}

.iidx-dan-head > span {
  flex-shrink: 0;
  border: 1px solid #d4d4d8;
  border-radius: 999px;
  padding: 5px 9px;
  color: #52525b;
  background: #f4f4f5;
  font-size: 11px;
  font-weight: 700;
}

.iidx-dan-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1px;
  background: #d4d4d8;
}

.iidx-dan-card {
  min-width: 0;
  padding: 14px;
  background: #ffffff;
}

.iidx-dan-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.iidx-dan-card-head h3 {
  margin: 0;
  color: #18181b;
  font-size: 16px;
  font-weight: 800;
}

.iidx-dan-card-head p {
  margin: 4px 0 0;
  color: #71717a;
  font-size: 11px;
  line-height: 1.35;
}

.iidx-dan-status {
  flex-shrink: 0;
  border: 1px solid #d4d4d8;
  border-radius: 999px;
  padding: 5px 8px;
  color: #52525b;
  background: #f4f4f5;
  font-size: 11px;
  font-weight: 800;
}

.iidx-dan-status.is-passed {
  border-color: rgba(16, 185, 129, 0.38);
  color: #047857;
  background: rgba(16, 185, 129, 0.1);
}

.iidx-dan-progress {
  overflow: hidden;
  height: 5px;
  margin: 12px 0;
  border-radius: 999px;
  background: #e4e4e7;
}

.iidx-dan-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2563eb, #f59e0b);
}

.iidx-dan-songs {
  display: grid;
  gap: 7px;
}

.iidx-dan-song {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  min-width: 0;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 8px;
  background: #fafafa;
}

.iidx-dan-song.is-satisfied {
  border-color: rgba(16, 185, 129, 0.32);
  background: rgba(16, 185, 129, 0.08);
}

.iidx-dan-song-main {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.iidx-dan-song-main .iidx-difficulty {
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
}

.iidx-dan-song-main div {
  min-width: 0;
}

.iidx-dan-song-main strong,
.iidx-dan-song-main small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iidx-dan-song-main strong {
  color: #18181b;
  font-size: 12px;
  line-height: 1.25;
}

.iidx-dan-song-main small {
  margin-top: 2px;
  color: #71717a;
  font-size: 10px;
}

.iidx-dan-record {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  min-width: 78px;
}

.iidx-dan-record span {
  color: #52525b;
  font-size: 10px;
  white-space: nowrap;
}

.iidx-dan-record b {
  color: #dc2626;
  font-size: 10px;
}

.iidx-dan-song.is-satisfied .iidx-dan-record b {
  color: #047857;
}

.iidx-dan-empty {
  padding: 28px 16px;
  color: #71717a;
  text-align: center;
  font-size: 13px;
}

.iidx-root.theme-dark .iidx-dan-panel {
  border-color: #3f3f46;
  background: #18181b;
}

.iidx-root.theme-dark .iidx-dan-head {
  border-bottom-color: #27272a;
  background: #18181b;
}

.iidx-root.theme-dark .iidx-dan-head h2,
.iidx-root.theme-dark .iidx-dan-card-head h3,
.iidx-root.theme-dark .iidx-dan-song-main strong {
  color: #f4f4f5;
}

.iidx-root.theme-dark .iidx-dan-head p,
.iidx-root.theme-dark .iidx-dan-card-head p,
.iidx-root.theme-dark .iidx-dan-song-main small,
.iidx-root.theme-dark .iidx-dan-record span,
.iidx-root.theme-dark .iidx-dan-empty {
  color: #a1a1aa;
}

.iidx-root.theme-dark .iidx-dan-head > span,
.iidx-root.theme-dark .iidx-dan-status {
  border-color: #3f3f46;
  background: #27272a;
  color: #d4d4d8;
}

.iidx-root.theme-dark .iidx-dan-grid {
  background: #27272a;
}

.iidx-root.theme-dark .iidx-dan-card {
  background: #18181b;
}

.iidx-root.theme-dark .iidx-dan-song {
  border-color: #27272a;
  background: #09090b;
}

.iidx-root.theme-dark .iidx-dan-status.is-passed {
  border-color: rgba(52, 211, 153, 0.38);
  color: #6ee7b7;
  background: rgba(16, 185, 129, 0.12);
}

.iidx-root.theme-dark .iidx-dan-progress {
  background: #27272a;
}

.iidx-root.theme-dark .iidx-dan-record b {
  color: #f87171;
}

.iidx-root.theme-dark .iidx-dan-song.is-satisfied .iidx-dan-record b {
  color: #6ee7b7;
}

.iidx-filter-row {
  display: grid;
  grid-template-columns: 126px 92px 116px 132px 168px 58px;
  gap: 6px;
}

.iidx-filter-row.is-direct {
  grid-template-columns: 126px 116px 132px 168px 58px;
}

.iidx-control,
.iidx-clear,
.iidx-sort-toggle {
  height: 30px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #18181b;
  font-size: 12px;
}

.iidx-control {
  min-width: 0;
  padding: 0 8px;
}

.iidx-sort-segment {
  display: grid;
  min-width: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid #d4d4d8;
  background: #ffffff;
}

.iidx-sort-option {
  display: inline-flex;
  min-width: 0;
  height: 28px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-right: 1px solid #e4e4e7;
  background: transparent;
  color: #52525b;
  padding: 0 6px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}

.iidx-sort-option:last-child {
  border-right: 0;
}

.iidx-sort-option.is-active {
  background: #ecfeff;
  color: #155e75;
}

.iidx-search {
  width: 100%;
}

.iidx-search-summary {
  grid-column: 1/-1;
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
  color: #52525b;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
}

.iidx-search-summary span {
  display: inline-flex;
  height: 18px;
  align-items: center;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  padding: 0 7px;
  white-space: nowrap;
}

.iidx-sort-toggle {
  min-width: 0;
  overflow: hidden;
  padding: 0 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iidx-sort-toggle:hover {
  border-color: #155e75;
  color: #0e7490;
}

.iidx-clear {
  padding: 0 8px;
}

.iidx-clear:disabled {
  color: #a1a1aa;
  cursor: not-allowed;
}

.iidx-progress-panel {
  display: grid;
  gap: 5px;
  margin-top: 6px;
  border-top: 1px solid #e4e4e7;
  padding-top: 6px;
}

.iidx-progress-head {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  color: #52525b;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
}

.iidx-progress-row {
  display: grid;
  grid-template-columns: 46px minmax(150px, 220px) minmax(0, 1fr);
  gap: 8px;
  align-items: center;
  min-width: 0;
}

.iidx-progress-type {
  color: #71717a;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
}

.iidx-progress-track {
  display: flex;
  min-width: 0;
  height: 8px;
  overflow: hidden;
  border: 1px solid #d4d4d8;
  border-radius: 4px;
  background: #e4e4e7;
}

.iidx-progress-segment {
  display: block;
  min-width: 1px;
  height: 100%;
}

.iidx-progress-legend {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 4px 8px;
  color: #52525b;
  font-size: 10px;
  line-height: 1.15;
}

.iidx-progress-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.iidx-progress-chip i {
  display: inline-block;
  width: 7px;
  height: 7px;
  flex: 0 0 auto;
  border: 1px solid rgba(24, 24, 27, 0.22);
  border-radius: 50%;
}

.iidx-scroll {
  scrollbar-width: thin;
  scrollbar-color: #a1a1aa transparent;
}

.iidx-scroll::-webkit-scrollbar {
  height: 5px;
}

.iidx-scroll::-webkit-scrollbar-thumb {
  background: #a1a1aa;
}

.iidx-main {
  padding-top: 7px;
  padding-bottom: 24px;
}

.iidx-update-panel {
  display: grid;
  gap: 8px;
  margin-bottom: 8px;
  border: 1px solid #a1a1aa;
  background: #ffffff;
  padding: 9px;
}

.iidx-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(24, 24, 27, 0.46);
  padding: 14px;
}

.iidx-update-modal {
  width: min(760px, 100%);
  max-height: min(680px, 100vh - 28px);
  overflow: auto;
  border: 1px solid #a1a1aa;
  background: #ffffff;
  color: #18181b;
  box-shadow: 0 18px 50px rgba(24, 24, 27, 0.25);
}

.iidx-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #d4d4d8;
  padding: 10px 12px;
}

.iidx-modal-close {
  display: inline-flex;
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #52525b;
  padding: 0;
  font-size: 18px;
  line-height: 1;
}

.iidx-modal-body {
  display: grid;
  gap: 10px;
  padding: 12px;
}

.iidx-modal-login,
.iidx-modal-actions {
  display: flex;
  gap: 6px;
}

.iidx-update-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.iidx-update-title {
  min-width: 0;
}

.iidx-update-title h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}

.iidx-update-title p {
  margin: 3px 0 0;
  overflow: hidden;
  color: #52525b;
  font-size: 11px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iidx-update-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
}

.iidx-update-btn,
.iidx-copy-btn {
  display: inline-flex;
  height: 28px;
  align-items: center;
  justify-content: center;
  border: 1px solid #a1a1aa;
  background: #ffffff;
  color: #18181b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
}

.iidx-update-btn {
  min-width: 62px;
  padding: 0 10px;
}

.iidx-update-btn.primary {
  border-color: #155e75;
  background: #164e63;
  color: #ecfeff;
}

.iidx-update-btn.danger {
  border-color: #fca5a5;
  color: #991b1b;
}

.iidx-update-btn:disabled,
.iidx-copy-btn:disabled {
  color: #a1a1aa;
  cursor: not-allowed;
}

.iidx-update-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 190px;
  gap: 8px;
  align-items: start;
}

.iidx-update-field {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.iidx-update-field.compact {
  align-content: start;
}

.iidx-update-field.is-script {
  grid-column: 1/-1;
}

.iidx-update-label {
  color: #71717a;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
}

.iidx-code-line {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 52px;
  min-width: 0;
  border: 1px solid #d4d4d8;
  background: #f4f4f5;
}

.iidx-code-line.iidx-script-line {
  grid-template-columns: minmax(0, 1fr) 52px 52px 52px;
}

.iidx-code-line code,
.iidx-script-code {
  min-width: 0;
  overflow: hidden;
  padding: 7px 8px;
  border: 0;
  background: transparent;
  color: #27272a;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iidx-script-code {
  width: 100%;
  height: 30px;
  resize: none;
}

.iidx-script-code:focus {
  outline: 1px solid #0891b2;
  outline-offset: -1px;
}

.iidx-copy-btn {
  width: 52px;
  height: 100%;
  border: 0;
  border-left: 1px solid #d4d4d8;
  background: #ffffff;
}

.iidx-update-help,
.iidx-update-message {
  color: #71717a;
  font-size: 10px;
  line-height: 1.25;
}

.iidx-update-field strong {
  overflow: hidden;
  color: #27272a;
  font-size: 12px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iidx-record-modal {
  width: min(420px, 100%);
}

.iidx-record-alert {
  border: 1px solid #fecaca;
  background: #fef2f2;
  color: #b91c1c;
  padding: 8px;
  font-size: 12px;
  line-height: 1.35;
}

.iidx-record-grid {
  display: grid;
  gap: 8px;
}

.iidx-record-field {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.iidx-record-field span,
.iidx-record-field small {
  color: #71717a;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
}

.iidx-record-field small {
  font-weight: 500;
}

.iidx-update-message {
  grid-column: 1/-1;
  color: #0e7490;
}

.iidx-update-message.is-error {
  color: #b91c1c;
}

.iidx-update-status-line {
  display: grid;
  gap: 3px;
  border: 1px solid #bae6fd;
  background: #ecfeff;
  color: #0e7490;
  padding: 8px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
}

.iidx-update-status-line.is-error {
  border-color: #fecaca;
  background: #fef2f2;
  color: #b91c1c;
}

.iidx-update-status-error {
  color: #b91c1c;
}

.iidx-loading,
.iidx-empty {
  display: flex;
  min-height: 260px;
  align-items: center;
  justify-content: center;
  color: #71717a;
  font-size: 13px;
}

.iidx-loading {
  flex-direction: column;
  gap: 10px;
}

.iidx-spinner {
  width: 28px;
  height: 28px;
  border: 2px solid #d4d4d8;
  border-top-color: #18181b;
  border-radius: 50%;
  animation: iidx-spin 0.8s linear infinite;
}

.iidx-weekly-panel {
  margin-bottom: 8px;
  border: 1px solid #a1a1aa;
  background: #ffffff;
}

.iidx-weekly-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #d4d4d8;
  padding: 8px 9px;
}

.iidx-weekly-title {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.iidx-weekly-mark {
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #155e75;
  background: #164e63;
  color: #ecfeff;
  font-size: 12px;
  font-weight: 600;
}

.iidx-weekly-title h2 {
  margin: 0;
  color: #18181b;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
}

.iidx-weekly-title p {
  margin: 2px 0 0;
  color: #71717a;
  font-size: 10px;
  line-height: 1.2;
}

.iidx-weekly-count {
  flex: 0 0 auto;
  color: #52525b;
  font-size: 11px;
  font-weight: 600;
}

.iidx-weekly-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.iidx-weekly-card {
  position: relative;
  min-width: 0;
  overflow: hidden;
  border-right: 1px solid #d4d4d8;
  border-bottom: 1px solid #e4e4e7;
  padding: 7px 8px 7px 15px;
}

.iidx-weekly-card-top {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 6px;
}

.iidx-weekly-song {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 4px;
}

.iidx-weekly-song-title {
  min-width: 0;
  overflow: hidden;
  color: #18181b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iidx-weekly-meta,
.iidx-weekly-record {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 5px;
  margin-top: 5px;
  overflow: hidden;
  padding-right: 30px;
  color: #71717a;
  font-size: 10px;
  line-height: 1.2;
  white-space: nowrap;
}

.iidx-weekly-tier {
  display: inline-flex;
  height: 17px;
  align-items: center;
  border-left: 3px solid #a1a1aa;
  background: #f4f4f5;
  color: #27272a;
  padding: 0 5px;
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
}

.iidx-weekly-tag {
  display: inline-flex;
  height: 17px;
  align-items: center;
  background: #ecfeff;
  color: #155e75;
  padding: 0 5px;
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
}

.iidx-weekly-reason {
  margin: 6px 0 0;
  overflow: hidden;
  padding-right: 30px;
  color: #52525b;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@keyframes iidx-spin {
  to {
    transform: rotate(360deg);
  }
}
.iidx-table {
  border-top: 1px solid #a1a1aa;
  border-left: 1px solid #a1a1aa;
  background: #ffffff;
}

.iidx-tier-row {
  display: grid;
  grid-template-columns: 142px minmax(0, 1fr);
  border-bottom: 1px solid #a1a1aa;
}

.iidx-tier-label {
  position: relative;
  display: flex;
  min-height: 46px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-right: 1px solid #a1a1aa;
  padding: 6px;
  text-align: center;
}

.iidx-tier-name {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.15;
}

.iidx-tier-count {
  min-width: 24px;
  color: currentColor;
  font-size: 11px;
  font-weight: 600;
  opacity: 0.72;
}

.iidx-song-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.iidx-song-cell {
  position: relative;
  min-width: 0;
  min-height: 46px;
  overflow: hidden;
  border-right: 1px solid #d4d4d8;
  border-bottom: 1px solid #e4e4e7;
  background: #ffffff;
  padding: 5px 6px 5px 14px;
}

.iidx-lamp-line {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 7px;
  background: #f87171;
}

.lamp-failed {
  background: #f87171;
}

.lamp-none {
  display: none;
}

.lamp-assist {
  background: #c084fc;
}

.lamp-easy {
  background: #bef264;
}

.lamp-normal {
  background: #2563eb;
}

.lamp-hard {
  background: #ffffff;
  box-shadow: inset -1px 0 0 #d4d4d8;
}

.lamp-ex-hard {
  background: #fde047;
}

.lamp-full-combo {
  background: #7dd3fc;
}

.iidx-song-top {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;
}

.iidx-title-wrap {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 4px;
}

.iidx-top-action {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: auto;
  height: 17px;
}

.iidx-difficulty {
  flex: 0 0 auto;
  color: #52525b;
  font-size: 10px;
  font-weight: 600;
}

.iidx-difficulty.is-legen {
  color: #be123c;
  font-size: 12px;
}

.iidx-difficulty.is-hyper {
  color: #0e7490;
}

.iidx-song-title {
  min-width: 0;
  overflow: hidden;
  color: #18181b;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iidx-title-tooltip {
  position: fixed;
  z-index: 80;
  max-width: min(420px, 100vw - 16px);
  border: 1px solid #27272a;
  border-radius: 4px;
  background: #18181b;
  box-shadow: 0 10px 24px rgba(24, 24, 27, 0.26);
  color: #f4f4f5;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  padding: 6px 8px;
  pointer-events: none;
  text-align: center;
  transform: translate(-50%, -100%);
  white-space: normal;
}

.iidx-title-tooltip.is-below {
  transform: translate(-50%, 0);
}

.iidx-youtube,
.iidx-record-button,
.iidx-textage {
  display: inline-flex;
  flex: 0 0 auto;
  width: 28px;
  height: 17px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 0;
}

.iidx-youtube {
  border: 0;
  background: transparent;
  color: #a1a1aa;
}

.iidx-record-button {
  border: 0;
  background: transparent;
  color: #71717a;
}

.iidx-record-button:hover {
  color: #0e7490;
}

.iidx-record-button svg {
  width: 12px;
  height: 12px;
}

.iidx-youtube:hover {
  color: #dc2626;
}

.iidx-youtube svg {
  width: 13px;
  height: 13px;
}

.iidx-textage {
  border: 1px solid #d4d4d8;
  background: #f4f4f5;
  color: #52525b;
  font-size: 9px;
  font-weight: 600;
  line-height: 1;
  margin: 0;
  z-index: 2;
}

.iidx-textage-card {
  position: absolute;
  right: 6px;
  bottom: 5px;
}

.iidx-textage-weekly {
  position: absolute;
  right: 8px;
  bottom: 29px;
}

.iidx-textage:hover {
  border-color: #155e75;
  color: #0e7490;
}

.iidx-song-meta {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
  margin-top: 3px;
  overflow: hidden;
  padding-right: 30px;
  color: #71717a;
  font-size: 10px;
  line-height: 1.2;
  white-space: nowrap;
}

.iidx-song-record {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  overflow: hidden;
  padding-right: 30px;
  white-space: nowrap;
}

.iidx-clear-badge,
.iidx-rank-text {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  min-width: 0;
  height: 16px;
  border: 1px solid #d4d4d8;
  background: #f4f4f5;
  color: #52525b;
  padding: 0 4px;
  font-size: 9px;
  font-weight: 600;
  line-height: 1;
}

.iidx-score-text {
  display: inline-block;
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  color: #155e75;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iidx-rank-text {
  color: #52525b;
}

.clear-f-combo,
.clear-exh-clear {
  border-color: #71717a;
  background: #e4e4e7;
  color: #18181b;
}

.clear-h-clear,
.clear-clear {
  border-color: #a1a1aa;
  background: #f4f4f5;
  color: #27272a;
}

.clear-e-clear,
.clear-a-clear {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #3f3f46;
}

.clear-failed {
  border-color: #a1a1aa;
  background: #f4f4f5;
  color: #52525b;
}

.iidx-root.theme-dark {
  background: #09090b;
  color: #f4f4f5;
}

.iidx-root.theme-dark .iidx-header {
  border-bottom-color: #27272a;
  background: rgba(24, 24, 27, 0.96);
}

.iidx-root.theme-dark .iidx-theme-toggle,
.iidx-root.theme-dark .iidx-play-link,
.iidx-root.theme-dark .iidx-update-open,
.iidx-root.theme-dark .iidx-tier-tab,
.iidx-root.theme-dark .iidx-sort-toggle,
.iidx-root.theme-dark .iidx-sort-segment,
.iidx-root.theme-dark .iidx-sort-option,
.iidx-root.theme-dark .iidx-control,
.iidx-root.theme-dark .iidx-clear,
.iidx-root.theme-dark .iidx-textage,
.iidx-root.theme-dark .iidx-update-btn,
.iidx-root.theme-dark .iidx-copy-btn,
.iidx-root.theme-dark .iidx-modal-close {
  border-color: #3f3f46;
  background: #18181b;
  color: #d4d4d8;
}

.iidx-root.theme-dark .iidx-theme-toggle:hover {
  border-color: #22d3ee;
  color: #67e8f9;
}

.iidx-root.theme-dark .iidx-sort-toggle:hover {
  border-color: #22d3ee;
  color: #67e8f9;
}

.iidx-root.theme-dark .iidx-update-open:hover {
  border-color: #22d3ee;
  color: #67e8f9;
}

.iidx-root.theme-dark .iidx-export-spinner {
  border-color: #3f3f46;
  border-top-color: #67e8f9;
}

.iidx-root.theme-dark .iidx-textage:hover {
  border-color: #22d3ee;
  color: #67e8f9;
}

.iidx-root.theme-dark .iidx-update-btn.primary {
  border-color: #155e75;
  background: #164e63;
  color: #ecfeff;
}

.iidx-root.theme-dark .iidx-update-btn.danger {
  border-color: #7f1d1d;
  color: #fecaca;
}

.iidx-root.theme-dark .iidx-play-link.is-active {
  border-color: #22d3ee;
  background: #164e63;
  color: #ecfeff;
}

.iidx-root.theme-dark .iidx-nav a,
.iidx-root.theme-dark .iidx-tier-tab,
.iidx-root.theme-dark .iidx-clear {
  color: #a1a1aa;
}

.iidx-root.theme-dark .iidx-nav a:hover,
.iidx-root.theme-dark .iidx-play-link.is-active,
.iidx-root.theme-dark .iidx-tier-tab.is-active,
.iidx-root.theme-dark .iidx-clear:hover {
  color: #f4f4f5;
}

.iidx-root.theme-dark .iidx-update-panel,
.iidx-root.theme-dark .iidx-update-modal,
.iidx-root.theme-dark .iidx-weekly-panel,
.iidx-root.theme-dark .iidx-table,
.iidx-root.theme-dark .iidx-song-cell {
  background: #18181b;
}

.iidx-root.theme-dark .iidx-update-panel,
.iidx-root.theme-dark .iidx-update-modal,
.iidx-root.theme-dark .iidx-modal-head,
.iidx-root.theme-dark .iidx-weekly-panel,
.iidx-root.theme-dark .iidx-weekly-head,
.iidx-root.theme-dark .iidx-table,
.iidx-root.theme-dark .iidx-tier-row,
.iidx-root.theme-dark .iidx-tier-label {
  border-color: #52525b;
}

.iidx-root.theme-dark .iidx-tier-label {
  background: #000000 !important;
  color: #f4f4f5 !important;
}

.iidx-root.theme-dark .iidx-control,
.iidx-root.theme-dark .iidx-clear,
.iidx-root.theme-dark .iidx-code-line,
.iidx-root.theme-dark .iidx-copy-btn,
.iidx-root.theme-dark .iidx-weekly-card,
.iidx-root.theme-dark .iidx-weekly-tier,
.iidx-root.theme-dark .iidx-sort-toggle,
.iidx-root.theme-dark .iidx-sort-segment,
.iidx-root.theme-dark .iidx-sort-option,
.iidx-root.theme-dark .iidx-song-cell,
.iidx-root.theme-dark .iidx-search-summary span,
.iidx-root.theme-dark .iidx-clear-badge,
.iidx-root.theme-dark .iidx-rank-text {
  border-color: #3f3f46;
}

.iidx-root.theme-dark .iidx-code-line,
.iidx-root.theme-dark .iidx-weekly-tier,
.iidx-root.theme-dark .iidx-weekly-tag,
.iidx-root.theme-dark .iidx-clear-badge,
.iidx-root.theme-dark .iidx-rank-text {
  background: #27272a;
}

.iidx-root.theme-dark .iidx-sort-option.is-active {
  background: #164e63;
  color: #ecfeff;
}

.iidx-root.theme-dark .iidx-copy-btn {
  background: #18181b;
}

.iidx-root.theme-dark .iidx-title-block h1,
.iidx-root.theme-dark .iidx-control,
.iidx-root.theme-dark .iidx-update-title h2,
.iidx-root.theme-dark .iidx-weekly-title h2,
.iidx-root.theme-dark .iidx-weekly-song-title,
.iidx-root.theme-dark .iidx-weekly-tier,
.iidx-root.theme-dark .iidx-weekly-tag,
.iidx-root.theme-dark .iidx-update-field strong,
.iidx-root.theme-dark .iidx-song-title {
  color: #f4f4f5;
}

.iidx-root.theme-dark .iidx-update-title p,
.iidx-root.theme-dark .iidx-weekly-title p,
.iidx-root.theme-dark .iidx-weekly-count,
.iidx-root.theme-dark .iidx-update-label,
.iidx-root.theme-dark .iidx-update-help,
.iidx-root.theme-dark .iidx-record-field span,
.iidx-root.theme-dark .iidx-record-field small,
.iidx-root.theme-dark .iidx-loading,
.iidx-root.theme-dark .iidx-empty,
.iidx-root.theme-dark .iidx-weekly-meta,
.iidx-root.theme-dark .iidx-weekly-reason,
.iidx-root.theme-dark .iidx-song-meta,
.iidx-root.theme-dark .iidx-difficulty {
  color: #a1a1aa;
}

.iidx-root.theme-dark .iidx-record-button {
  color: #a1a1aa;
}

.iidx-root.theme-dark .iidx-record-button:hover {
  color: #67e8f9;
}

.iidx-root.theme-dark .iidx-difficulty.is-legen {
  color: #c084fc;
}

.iidx-root.theme-dark .iidx-code-line code,
.iidx-root.theme-dark .iidx-script-code {
  color: #e4e4e7;
}

.iidx-root.theme-dark .iidx-update-message,
.iidx-root.theme-dark .iidx-score-text {
  color: #67e8f9;
}

.iidx-root.theme-dark .iidx-update-message.is-error {
  color: #fca5a5;
}

.iidx-root.theme-dark .iidx-update-status-line {
  border-color: #164e63;
  background: #083344;
  color: #67e8f9;
}

.iidx-root.theme-dark .iidx-update-status-line.is-error {
  border-color: #7f1d1d;
  background: #450a0a;
  color: #fca5a5;
}

.iidx-root.theme-dark .iidx-update-status-error {
  color: #fca5a5;
}

.iidx-root.theme-dark .iidx-record-alert {
  border-color: #7f1d1d;
  background: #450a0a;
  color: #fca5a5;
}

.iidx-root.theme-dark .iidx-progress-panel {
  border-top-color: #27272a;
}

.iidx-root.theme-dark .iidx-progress-head,
.iidx-root.theme-dark .iidx-progress-type,
.iidx-root.theme-dark .iidx-progress-legend,
.iidx-root.theme-dark .iidx-search-summary {
  color: #a1a1aa;
}

.iidx-root.theme-dark .iidx-search-summary span {
  background: #18181b;
}

.iidx-root.theme-dark .iidx-progress-track {
  border-color: #3f3f46;
  background: #27272a;
}

.iidx-root.theme-dark .iidx-progress-chip i {
  border-color: rgba(244, 244, 245, 0.28);
}

.iidx-root.theme-dark .iidx-rank-text {
  color: #fbbf24;
}

.iidx-root.theme-dark .iidx-spinner {
  border-color: #3f3f46;
  border-top-color: #f4f4f5;
}

.iidx-root.theme-dark .lamp-hard {
  box-shadow: inset -1px 0 0 #71717a;
}

.iidx-root.theme-dark .iidx-scroll {
  scrollbar-color: #71717a transparent;
}

.iidx-root.theme-dark .iidx-scroll::-webkit-scrollbar-thumb {
  background: #71717a;
}

.iidx-root.theme-dark .clear-f-combo,
.iidx-root.theme-dark .clear-exh-clear {
  border-color: #f59e0b;
  background: #451a03;
  color: #fde68a;
}

.iidx-root.theme-dark .clear-h-clear,
.iidx-root.theme-dark .clear-clear {
  border-color: #22c55e;
  background: #052e16;
  color: #bbf7d0;
}

.iidx-root.theme-dark .clear-e-clear,
.iidx-root.theme-dark .clear-a-clear {
  border-color: #06b6d4;
  background: #164e63;
  color: #cffafe;
}

.iidx-root.theme-dark .clear-failed {
  border-color: #ef4444;
  background: #450a0a;
  color: #fecaca;
}

@media (max-width: 980px) {
  .iidx-controls {
    grid-template-columns: 1fr;
  }
  .iidx-filter-row {
    grid-template-columns: 126px 90px 116px minmax(0, 1fr) minmax(0, 1fr) 58px;
  }
  .iidx-filter-row.is-direct {
    grid-template-columns: 126px 116px minmax(0, 1fr) minmax(0, 1fr) 58px;
  }
  .iidx-update-grid {
    grid-template-columns: 1fr;
  }
  .iidx-weekly-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .iidx-song-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .iidx-title-line {
    align-items: flex-start;
  }
  .iidx-nav {
    flex-shrink: 1;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 6px;
  }
}
@media (max-width: 640px) {
  .iidx-wrap {
    padding: 0 6px;
  }
  .iidx-title-block h1 {
    font-size: 15px;
  }
  .iidx-controls {
    gap: 6px;
  }
  .iidx-filter-row {
    grid-template-columns: 1fr 1fr;
  }
  .iidx-filter-row.is-direct {
    grid-template-columns: 1fr 1fr;
  }
  .iidx-sort-segment,
  .iidx-sort-toggle {
    grid-column: span 2;
  }
  .iidx-progress-panel {
    display: none;
  }
  .iidx-search,
  .iidx-clear {
    grid-column: span 2;
  }
  .iidx-update-head {
    align-items: stretch;
    flex-direction: column;
  }
  .iidx-update-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .iidx-update-btn {
    width: 100%;
  }
  .iidx-weekly-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .iidx-weekly-grid {
    grid-template-columns: 1fr;
  }
  .iidx-update-grid {
    grid-template-columns: 1fr;
  }
  .iidx-tier-row {
    grid-template-columns: 58px minmax(0, 1fr);
  }
  .iidx-tier-label {
    padding: 4px 3px;
  }
  .iidx-tier-name {
    font-size: 11px;
    line-height: 1.15;
  }
  .iidx-tier-count {
    display: none;
  }
  .iidx-song-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .iidx-song-cell {
    min-height: 52px;
    padding: 4px 4px 4px 11px;
  }
  .iidx-lamp-line {
    width: 5px;
  }
  .iidx-song-title {
    font-size: 11px;
  }
  .iidx-top-action {
    gap: 1px;
  }
  .iidx-youtube,
  .iidx-record-button,
  .iidx-textage {
    width: 22px;
  }
  .iidx-youtube svg {
    width: 12px;
    height: 12px;
  }
  .iidx-textage-card {
    right: 4px;
    bottom: 4px;
  }
  .iidx-song-meta,
  .iidx-song-record {
    padding-right: 24px;
  }
  .iidx-song-meta {
    gap: 4px;
    font-size: 9px;
  }
  .iidx-score-text {
    font-size: 9px;
  }
}`],
})
export class PageIidxComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public themeMode: ThemeMode = 'dark';
    public allData: any = null;
    public songs: any[] = [];
    public sections: any[] = [];
    public tiers: string[] = DEFAULT_TIERS;
    public danCourses: any[] = [];
    public tableMode: IidxTableMode = 'tier';
    public levels: number[] = [];
    public versions: any[] = [];
    public difficulties: string[] = [];
    public tableTitle: string = 'beatmania IIDX SP LEVEL 12 RANK TABLE';
    public tablePlayStyle: PlayStyle = 'SP';
    public selectedPlayStyle: PlayStyle = 'SP';
    public classificationMode: string = 'stacked-classification';

    public selectedTiers: string[] = [];
    public selectedLevelGroup: string = 'all';
    public selectedLevel: string = 'all';
    public selectedDifficulty: string = 'all';
    public selectedVersion: string = 'all';
    public searchText: string = '';
    public searchSummary: any = { query: '', total: 0, direct: 0, similar: 0 };
    public sortMode: SortMode = 'default';
    private readonly sortModeOrder: SortMode[] = ['default', 'clear', 'score'];
    private readonly similarSearchThreshold = 0.38;
    public titleTooltip: any = { visible: false, text: '', left: 0, top: 0, placement: 'above' };

    public updateInfo: any = { loggedIn: false, latest: null };
    public updateModalOpen: boolean = false;
    public recordModalOpen: boolean = false;
    public recordEditSong: any = null;
    public recordEditScore: string = '';
    public recordEditClearType: string = 'NO PLAY';
    public recordEditError: string = '';
    public recordSaving: boolean = false;
    public readonly iidxClearTypeOptions = IIDX_CLEAR_TYPE_OPTIONS;
    public updateToken: string = '';
    public updateTokenExpires: string = '';
    public updateStatusMessage: string = '';
    public latestDataIssue: string = '';
    public updateLoading: boolean = false;
    public refreshLoading: boolean = false;
    public bookmarkletCode: string = '';
    public copiedTarget: string = '';
    public latestScoreMap: any = {};
    public weeklyRecommendations: any[] = [];
    public weeklyKey: string = '';
    public weeklyRangeLabel: string = '';
    public weeklyLevel: number = 12;
    public weeklyLocked: boolean = false;
    public weeklyNextRefreshAt: string = '';
    private updatePollTimer: any = null;
    private updatePollStartedAt: number = 0;
    private updateBaselineUpdatedAt: number = 0;
    private updateScriptWindow: Window | null = null;
    public updateSessionWindowOpened: boolean = false;
    private iidxSongLookupMap: any = {};

    public stats: any = {
        visible: 0
    };
    public exportingChart: boolean = false;
    public progressStats: any = {
        total: 0,
        played: 0,
        scored: 0,
        lampItems: [],
        scoreItems: []
    };

    public tierPalette: any = {
        'S+': { bg: '#ffffff', fg: '#18181b', accent: '#52525b' },
        'S': { bg: '#ffffff', fg: '#18181b', accent: '#52525b' },
        'A+': { bg: '#ffffff', fg: '#27272a', accent: '#71717a' },
        'A': { bg: '#ffffff', fg: '#27272a', accent: '#71717a' },
        'B+': { bg: '#ffffff', fg: '#3f3f46', accent: '#a1a1aa' },
        'B': { bg: '#ffffff', fg: '#3f3f46', accent: '#a1a1aa' },
        'C': { bg: '#ffffff', fg: '#52525b', accent: '#71717a' },
        'D': { bg: '#ffffff', fg: '#52525b', accent: '#71717a' },
        'E': { bg: '#ffffff', fg: '#3f3f46', accent: '#a1a1aa' },
        'F': { bg: '#ffffff', fg: '#27272a', accent: '#71717a' },
        '미분류': { bg: '#ffffff', fg: '#52525b', accent: '#a1a1aa' }
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        this.themeMode = this.loadThemeMode();
        this.applyThemeMode();
        await this.service.init();
        this.selectedPlayStyle = this.getRoutePlayStyle();
        this.bookmarkletCode = this.buildBookmarkletCode();
        await this.load();
        await this.loadUpdateStatus(false);
    }

    public ngOnDestroy() {
        this.stopUpdateStatusPolling();
    }

    private loadThemeMode(): ThemeMode {
        try {
            const saved = localStorage.getItem(THEME_STORAGE_KEY);
            if (saved === 'dark' || saved === 'light') return saved;
        } catch { }
        return 'dark';
    }

    private applyThemeMode() {
        try {
            document.documentElement.setAttribute('data-taigo-theme', this.themeMode);
            document.documentElement.style.colorScheme = this.themeMode;
        } catch { }
    }

    private getRoutePlayStyle(): PlayStyle {
        const playStyle = String(WizRoute.segment.playStyle || '').trim().toLowerCase();
        return playStyle === 'dp' || playStyle === 'double' ? 'DP' : 'SP';
    }

    private getDefaultTableTitle(playStyle: PlayStyle = this.selectedPlayStyle): string {
        return playStyle === 'DP'
            ? 'beatmania IIDX DP UNOFFICIAL RANK TABLE'
            : 'beatmania IIDX SP LEVEL 12 RANK TABLE';
    }

    public isPlayStyleSelected(playStyle: PlayStyle): boolean {
        return this.selectedPlayStyle === playStyle;
    }

    public getThemeToggleLabel(): string {
        return this.themeMode === 'dark' ? '라이트 모드로 전환' : '다크 모드로 전환';
    }

    public async toggleThemeMode() {
        this.themeMode = this.themeMode === 'dark' ? 'light' : 'dark';
        try {
            localStorage.setItem(THEME_STORAGE_KEY, this.themeMode);
        } catch { }
        this.applyThemeMode();
        await this.service.render();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        try {
            this.selectedPlayStyle = this.getRoutePlayStyle();
            const { code, data } = await wiz.call("load", { playStyle: this.selectedPlayStyle, _ts: Date.now() });
            if (code === 200 && data) {
                this.allData = data;
                this.tableTitle = data.tableTitle || data.title || this.getDefaultTableTitle(this.selectedPlayStyle);
                this.tablePlayStyle = data.playStyle === 'DP' || this.selectedPlayStyle === 'DP' ? 'DP' : 'SP';
                this.classificationMode = 'stacked-classification';
                this.tiers = Array.isArray(data.tiers) && data.tiers.length ? data.tiers : DEFAULT_TIERS;
                this.danCourses = Array.isArray(data.danCourses)
                    ? data.danCourses.sort((left: any, right: any) => Number(left.order || 0) - Number(right.order || 0))
                    : [];
                this.versions = Array.isArray(data.versions) ? data.versions : [];
                this.difficulties = Array.isArray(data.difficulties) ? data.difficulties : [];
                this.songs = Array.isArray(data.songs) ? data.songs.map((song: any, index: number) => this.normalizeSong(song, index)) : [];
                this.iidxSongLookupMap = this.buildIidxSongLookupMap(this.songs);
                this.levels = this.normalizeLevels(data.levels, this.songs);
                this.selectedTiers = this.selectedTiers.filter((tier) => this.tiers.includes(tier));
                this.refreshView();
                await this.loadWeeklyRecommendations(false, true);
            }
        } catch {
            this.allData = null;
            this.songs = [];
            this.sections = [];
            this.progressStats = this.emptyIidxProgressStats();
        }

        this.loading = false;
        await this.service.render();
    }

    private normalizeSong(song: any, index: number) {
        const title = String(song.title || '').trim();
        const difficulty = String(song.difficulty || 'UNKNOWN').trim();
        const playStyle = song.playStyle === 'DP' || this.tablePlayStyle === 'DP' ? 'DP' : 'SP';
        const directRank = this.parseTierRank(song.tier || song.rank || song.hardRaw || song.hard || song.hardTier, song.hardSource);
        const hardRank = this.parseTierRank(song.hardRaw || song.hard || song.hardTier || song.tier, song.hardSource);
        const normalRank = this.parseTierRank(song.normalRaw || song.normal || song.normalTier, song.normalSource);
        const epRank = this.resolveHardClassificationRank('ep', hardRank);
        const idRank = this.resolveHardClassificationRank('id', hardRank);
        const baseSongKey = song.songKey || song.key || song.slug || song.id || `${title}-${difficulty}`;
        const songKey = `${baseSongKey}-${index}`;
        const directMode = this.isDirectTierMode();
        return {
            ...song,
            songKey,
            title,
            level: Number(song.level || 12),
            playStyle,
            difficulty,
            hardTier: hardRank.tier,
            hardRaw: hardRank.raw,
            hardSource: hardRank.source,
            normalTier: normalRank.tier,
            normalRaw: normalRank.raw,
            normalSource: normalRank.source,
            epTier: epRank.tier,
            epRaw: epRank.raw,
            epSource: epRank.source,
            idTier: idRank.tier,
            idRaw: idRank.raw,
            idSource: idRank.source,
            tier: directMode ? directRank.tier : epRank.tier,
            tierRaw: directRank.raw,
            version: String(song.version || '').trim(),
            versionLabel: song.versionLabel || (song.version ? `ver. ${song.version}` : '버전 미상'),
            primaryTag: this.normalizePrimaryTag(song.primaryTag),
            secondaryTags: this.normalizeSecondaryTags(song.secondaryTags),
            tagConfidence: Number(song.tagConfidence || 0),
            tagEvidence: song.tagEvidence || null,
            noteCount: Number(song.noteCount || 0),
            memo: directMode ? this.buildDirectTierMemo(directRank, song) : this.buildClassificationMemo(epRank, idRank),
            youtubeQuery: this.buildYoutubeQuery(title, difficulty, playStyle)
        };
    }

    private normalizePrimaryTag(value: any): string {
        const tag = String(value || '').trim();
        if (!tag || tag.toLowerCase() === 'unknown') return '발광';
        return tag;
    }

    private normalizeSecondaryTags(value: any): string[] {
        const values = Array.isArray(value) ? value : [];
        const seen: any = {};
        const tags: string[] = [];
        for (const item of values) {
            const tag = String(item || '').trim();
            if (!tag || tag.toLowerCase() === 'unknown' || seen[tag]) continue;
            seen[tag] = true;
            tags.push(tag);
        }
        return tags;
    }

    private normalizeLevels(levels: any, songs: any[]): number[] {
        const values = Array.isArray(levels) ? levels : songs.map((song) => song.level);
        const unique: any = {};
        for (const value of values) {
            const level = Number(value);
            if (!Number.isNaN(level) && level > 0) unique[String(level)] = level;
        }
        return Object.values(unique).sort((left: any, right: any) => Number(left) - Number(right)) as number[];
    }

    private buildClassificationMemo(epRank: any, idRank: any): string {
        const ep = epRank.raw || '미분류';
        const id = idRank.raw || '미분류';
        return `지력 ${ep} / 개인차 ${id}`;
    }

    private buildDirectTierMemo(rank: any, song: any): string {
        const tier = rank.raw || rank.tier || song.tier || '미분류';
        return `${this.getPlayStyleLabel()} ${tier}`;
    }

    private buildYoutubeQuery(title: string, difficulty: string, playStyle: PlayStyle = this.tablePlayStyle): string {
        if (!title) return '';
        const chartType = this.getChartType(difficulty, playStyle);
        return `${title} ${chartType} 正規`;
    }

    private getChartType(difficulty: any, playStyle: PlayStyle = this.tablePlayStyle): string {
        const prefix = playStyle === 'DP' ? 'DP' : 'SP';
        const normalized = String(difficulty || '').trim().toUpperCase();
        if (this.isLeggendariaDifficulty(normalized)) return `${prefix}L`;
        if (normalized === 'HYPER' || normalized === 'H') return `${prefix}H`;
        if (normalized === 'NORMAL' || normalized === 'N') return `${prefix}N`;
        return `${prefix}A`;
    }

    private isLeggendariaDifficulty(difficulty: any): boolean {
        const normalized = String(difficulty || '').trim().toUpperCase();
        return normalized === 'LEGGENDARIA' || normalized === '†';
    }

    private normalizeTier(value: any): string {
        const tier = String(value || '').trim();
        return this.tiers.includes(tier) ? tier : '미분류';
    }

    private normalizeClassificationSource(value: any): 'ep' | 'id' | '' {
        const source = String(value || '').trim().toLowerCase();
        return source === 'ep' || source === 'id' ? source : '';
    }

    private makeRank(source: 'ep' | 'id' | '', tier: string, raw: string) {
        const normalizedTier = this.normalizeTier(tier);
        return {
            source,
            tier: normalizedTier,
            raw: normalizedTier === '미분류' ? '' : (raw || `${source} ${normalizedTier}`).trim()
        };
    }

    private parseTierRank(value: any, sourceHint: any = '') {
        const raw = String(value || '').trim();
        const hintedSource = this.normalizeClassificationSource(sourceHint);
        const prefixed = raw.match(/^(ep|id)\s+(.+)$/i);

        if (prefixed) {
            const source = this.normalizeClassificationSource(prefixed[1]);
            return this.makeRank(source, prefixed[2].trim(), raw);
        }

        if (hintedSource) {
            return this.makeRank(hintedSource, raw, raw ? `${hintedSource} ${raw}` : '');
        }

        return this.makeRank('', raw, raw);
    }

    private resolveHardClassificationRank(source: 'ep' | 'id', hardRank: any) {
        if (hardRank.source === source && hardRank.tier !== '미분류') {
            return hardRank;
        }

        return this.makeRank(source, '미분류', '');
    }

    public isDirectTierMode(): boolean {
        return false;
    }

    private getCoreDirectLevels(): number[] {
        return [12, 11, 10];
    }

    private getOtherDirectLevels(): number[] {
        const coreLevels = this.getCoreDirectLevels();
        return this.levels
            .map((level) => Number(level))
            .filter((level) => !Number.isNaN(level) && !coreLevels.includes(level))
            .sort((left, right) => right - left);
    }

    private getSelectedDirectLevels(): number[] {
        if (this.selectedLevelGroup === 'all') {
            return this.levels.map((level) => Number(level)).filter((level) => !Number.isNaN(level));
        }

        if (this.selectedLevelGroup === 'other') return this.getOtherDirectLevels();

        const level = Number(this.selectedLevelGroup);
        return Number.isNaN(level) ? [] : [level];
    }

    public getTableTabs(): TableTab[] {
        if (!this.isDirectTierMode()) {
            return this.getDisplayTiers().map((tier) => ({
                value: tier,
                label: tier,
                accent: this.getTierAccent(tier)
            }));
        }

        const availableLevels = new Set(this.levels.map((level) => Number(level)).filter((level) => !Number.isNaN(level)));
        const tabs = this.getCoreDirectLevels()
            .filter((level) => availableLevels.has(level))
            .map((level) => ({
                value: String(level),
                label: `☆${level}`,
                accent: level === 12 ? '#ef4444' : level === 11 ? '#06b6d4' : '#3b82f6'
            }));

        if (this.getOtherDirectLevels().length) {
            tabs.push({
                value: 'other',
                label: '기타',
                accent: '#a1a1aa'
            });
        }

        return tabs;
    }

    public isTableTabSelected(value: string): boolean {
        return this.isDirectTierMode()
            ? this.selectedLevelGroup === value
            : value === 'all' ? this.selectedTiers.length === 0 : this.selectedTiers.includes(value);
    }

    public getTableTabAccent(tab: TableTab): string {
        return tab.accent || (this.isDirectTierMode() ? '#155e75' : this.getTierAccent(tab.value));
    }

    public selectTableTab(value: string) {
        this.tableMode = 'tier';
        if (this.isDirectTierMode()) {
            this.selectedLevelGroup = value;
        } else if (value === 'all') {
            this.selectedTiers = [];
        } else {
            this.selectedTiers = this.selectedTiers.includes(value)
                ? this.selectedTiers.filter((tier) => tier !== value)
                : [...this.selectedTiers, value];
        }
        this.refreshView();
    }

    public async selectDanMode() {
        this.tableMode = 'dan';
        await this.loadUpdateStatus(false, false, false);
        await this.service.render();
    }

    public isDanModeSelected(): boolean {
        return this.tableMode === 'dan';
    }

    public getSortModeLabel(): string {
        switch (this.sortMode) {
            case 'clear': return '정렬: 클리어순';
            case 'score': return '정렬: 스코어순';
            default: return '정렬: 기본';
        }
    }

    private getNextSortMode(): SortMode {
        const index = this.sortModeOrder.indexOf(this.sortMode);
        return this.sortModeOrder[(index + 1) % this.sortModeOrder.length];
    }

    public getSortToggleAriaLabel(): string {
        const nextLabel = this.getNextSortMode() === 'clear' ? '클리어순'
            : this.getNextSortMode() === 'score' ? '스코어순'
                : '기본';
        return `정렬 변경: 다음은 ${nextLabel}`;
    }

    public cycleSortMode() {
        this.sortMode = this.getNextSortMode();
        this.refreshView();
    }

    private getDisplayTiers(): string[] {
        return [...this.tiers].sort((left, right) => {
            const leftValue = Number(left);
            const rightValue = Number(right);
            const leftNumeric = !Number.isNaN(leftValue);
            const rightNumeric = !Number.isNaN(rightValue);

            if (leftNumeric && rightNumeric) return rightValue - leftValue;
            if (leftNumeric) return -1;
            if (rightNumeric) return 1;
            return this.tiers.indexOf(left) - this.tiers.indexOf(right);
        });
    }

    public refreshView() {
        const filtered = this.getFilteredSongs();
        const sections: any[] = [];
        let visible = 0;

        for (const tier of this.getDisplayTiers()) {
            if (!this.isDirectTierMode() && this.selectedTiers.length > 0 && !this.selectedTiers.includes(tier)) continue;

            if (this.isDirectTierMode()) {
                const tierSongs = filtered.filter((song) => this.normalizeTier(song.tier) === tier);
                if (tierSongs.length) {
                    sections.push(this.buildSection(tier, tier, 'rank', tierSongs));
                    visible += tierSongs.length;
                }
                continue;
            }

            if (tier === '미분류') {
                const unclassifiedSongs = filtered.filter((song) => !this.hasClassificationFor(song, 'ep') && !this.hasClassificationFor(song, 'id'));
                if (unclassifiedSongs.length) {
                    sections.push(this.buildSection(tier, '미분류', 'unclassified', unclassifiedSongs));
                    visible += unclassifiedSongs.length;
                }
                continue;
            }

            for (const section of CLASSIFICATION_SECTIONS) {
                const tierSongs = filtered.filter((song) => this.getSongTierFor(song, section.value) === tier);
                if (!tierSongs.length) continue;
                sections.push(this.buildSection(tier, `${section.label} ${tier}`, section.value, tierSongs));
                visible += tierSongs.length;
            }
        }

        this.sections = sections;
        this.stats = {
            visible
        };
        this.progressStats = this.calculateIidxProgressStats(sections);
        this.service.render();
    }

    private emptyIidxProgressStats() {
        return {
            total: 0,
            played: 0,
            scored: 0,
            lampItems: [],
            scoreItems: []
        };
    }

    private calculateIidxProgressStats(sections: any[]) {
        const uniqueSongs: any = {};
        for (const section of sections || []) {
            for (const song of section.songs || []) {
                const key = song.songKey || `${song.title}-${song.difficulty}-${song.level}`;
                if (!uniqueSongs[key]) uniqueSongs[key] = song;
            }
        }

        const songs = Object.values(uniqueSongs) as any[];
        const total = songs.length;
        if (!total) return this.emptyIidxProgressStats();

        const lampCounts: any = {};
        const scoreCounts: any = {};
        let played = 0;
        let scored = 0;

        for (const song of songs) {
            const record = this.getSongRecord(song);
            const lampKey = this.getLampProgressKey(record);
            const scoreKey = this.getScoreProgressKey(song, record);
            lampCounts[lampKey] = (lampCounts[lampKey] || 0) + 1;
            scoreCounts[scoreKey] = (scoreCounts[scoreKey] || 0) + 1;
            if (lampKey !== 'no-play') played++;
            if (scoreKey !== 'none') scored++;
        }

        return {
            total,
            played,
            scored,
            lampItems: this.buildIidxProgressItems(IIDX_LAMP_PROGRESS_ITEMS, lampCounts, total),
            scoreItems: this.buildIidxProgressItems(IIDX_SCORE_PROGRESS_ITEMS, scoreCounts, total)
        };
    }

    private buildIidxProgressItems(items: any[], counts: any, total: number): any[] {
        return items
            .map((item) => {
                const count = Number(counts[item.key] || 0);
                return {
                    ...item,
                    count,
                    percent: total > 0 ? `${(count / total) * 100}%` : '0%'
                };
            })
            .filter((item) => item.count > 0);
    }

    private getLampProgressKey(record: any): string {
        if (!this.hasIidxAttemptRecord(record)) return 'no-play';
        const value = this.getNormalizedClearType(record);
        if (this.isNoPlayClearType(value)) return 'no-play';
        if (value.includes('F-COMBO') || value.includes('FULL-COMBO') || value.includes('FULLCOMBO')) return 'full-combo';
        if (value.includes('EXH') || value.includes('EX-HARD') || value.includes('EX-H-CLEAR')) return 'ex-hard';
        if (value.includes('H-CLEAR') || value.includes('HARD')) return 'hard';
        if (value.includes('A-CLEAR') || value.includes('ASSIST')) return 'assist';
        if (value.includes('E-CLEAR') || value.includes('EASY')) return 'easy';
        if (value.includes('CLEAR') || value.includes('NORMAL')) return 'normal';
        return 'failed';
    }

    private getScoreProgressKey(song: any, record: any): string {
        if (!record) return 'none';
        const rank = this.getNormalizedRankLabel(record.rank);
        const scoreKeys = IIDX_SCORE_PROGRESS_ITEMS.map((item) => item.key);
        const noteCount = Number(song && song.noteCount || record.noteCount || 0);
        const score = this.normalizeIidxScoreValue(record.score, noteCount);

        if (score > 0 && noteCount > 0) {
            const maxScore = noteCount * 2;
            if (score >= maxScore) return 'MAX';
            if (score >= this.iidxScoreBorder(maxScore, 8)) return 'AAA';
            if (score >= this.iidxScoreBorder(maxScore, 7)) return 'AA';
            if (score >= this.iidxScoreBorder(maxScore, 6)) return 'A';
            if (score >= this.iidxScoreBorder(maxScore, 5)) return 'B';
            if (score >= this.iidxScoreBorder(maxScore, 4)) return 'C';
            if (score >= this.iidxScoreBorder(maxScore, 3)) return 'D';
            if (score >= this.iidxScoreBorder(maxScore, 2)) return 'E';
            return 'F';
        }

        if (rank && scoreKeys.includes(rank)) return rank;
        if (score > 0) return 'scored';
        return 'none';
    }

    private buildSection(tier: string, label: string, source: string, songs: any[]) {
        return {
            id: `${tier}-${source}`,
            name: tier,
            label,
            source,
            songs: this.sortSongs(songs),
            color: this.getTierTextColor(tier),
            backgroundColor: this.getTierBackground(tier),
            accent: this.getTierAccent(tier),
            lampLineClass: this.getSectionLampLineClass(songs)
        };
    }

    private sortSongs(songs: any[]): any[] {
        if (this.hasSearchQuery()) {
            return [...songs].sort((left, right) => {
                const searchDiff = Number(right.searchScore || 0) - Number(left.searchScore || 0);
                if (Math.abs(searchDiff) > 0.0001) return searchDiff;

                if (this.sortMode === 'clear') {
                    const leftLamp = this.getLampSortValue(this.getSongRecord(left));
                    const rightLamp = this.getLampSortValue(this.getSongRecord(right));
                    if (leftLamp !== rightLamp) return rightLamp - leftLamp;

                    const scoreDiff = this.getSongScoreSortValue(right) - this.getSongScoreSortValue(left);
                    if (scoreDiff !== 0) return scoreDiff;
                }

                if (this.sortMode === 'score') {
                    const scoreDiff = this.getSongScoreSortValue(right) - this.getSongScoreSortValue(left);
                    if (scoreDiff !== 0) return scoreDiff;

                    const lampDiff = this.getLampSortValue(this.getSongRecord(right)) - this.getLampSortValue(this.getSongRecord(left));
                    if (lampDiff !== 0) return lampDiff;
                }

                return this.compareDefaultSongs(left, right);
            });
        }

        if (this.sortMode !== 'default') return this.sortSongsByMode(songs);
        return [...songs].sort((left, right) => {
            return this.compareDefaultSongs(left, right);
        });
    }

    private getSectionLampLineClass(songs: any[]): string {
        if (!Array.isArray(songs) || !songs.length) return '';

        const order = ['no-play', 'failed', 'assist', 'easy', 'normal', 'hard', 'ex-hard', 'full-combo'];
        const classes: any = {
            'no-play': 'lamp-none',
            failed: 'lamp-failed',
            assist: 'lamp-assist',
            easy: 'lamp-easy',
            normal: 'lamp-normal',
            hard: 'lamp-hard',
            'ex-hard': 'lamp-ex-hard',
            'full-combo': 'lamp-full-combo'
        };
        let weakest = order[order.length - 1];

        for (const song of songs) {
            const key = this.getLampProgressKey(this.getSongRecord(song));
            if (order.indexOf(key) < order.indexOf(weakest)) weakest = key;
        }

        return `iidx-lamp-line ${classes[weakest] || classes['no-play']}`;
    }

    private sortSongsByMode(songs: any[]): any[] {
        return [...songs].sort((left, right) => {
            if (this.sortMode === 'clear') {
                const leftLamp = this.getLampSortValue(this.getSongRecord(left));
                const rightLamp = this.getLampSortValue(this.getSongRecord(right));
                if (leftLamp !== rightLamp) return rightLamp - leftLamp;

                const scoreDiff = this.getSongScoreSortValue(right) - this.getSongScoreSortValue(left);
                if (scoreDiff !== 0) return scoreDiff;
            }

            if (this.sortMode === 'score') {
                const scoreDiff = this.getSongScoreSortValue(right) - this.getSongScoreSortValue(left);
                if (scoreDiff !== 0) return scoreDiff;

                const lampDiff = this.getLampSortValue(this.getSongRecord(right)) - this.getLampSortValue(this.getSongRecord(left));
                if (lampDiff !== 0) return lampDiff;
            }

            return this.compareDefaultSongs(left, right);
        });
    }

    private compareDefaultSongs(left: any, right: any): number {
        if (this.isDirectTierMode()) {
            const leftOrder = Number(left.sourceOrder ?? 0);
            const rightOrder = Number(right.sourceOrder ?? 0);
            if (leftOrder !== rightOrder) return leftOrder - rightOrder;
        }
        const leftTitle = this.getSortTitle(left.title);
        const rightTitle = this.getSortTitle(right.title);
        if (leftTitle > rightTitle) return 1;
        if (leftTitle < rightTitle) return -1;
        return String(left.difficulty || '').localeCompare(String(right.difficulty || ''));
    }

    private getSortTitle(title: string): string {
        return String(title || '').replace(/^†+/, '').toLowerCase();
    }

    public getFilteredSongs(): any[] {
        const query = this.normalizeSearch(this.searchText);
        const filtered: any[] = [];
        let direct = 0;
        let similar = 0;

        for (const song of this.songs) {
            if (this.isDirectTierMode()) {
                const selectedLevels = this.getSelectedDirectLevels();
                if (selectedLevels.length && !selectedLevels.includes(Number(song.level))) continue;
            } else if (this.selectedLevel !== 'all' && String(song.level) !== this.selectedLevel) {
                continue;
            }
            if (this.selectedDifficulty !== 'all' && song.difficulty !== this.selectedDifficulty) continue;
            if (this.selectedVersion !== 'all' && song.version !== this.selectedVersion) continue;

            if (query) {
                const match = this.scoreSongSearch(song, query);
                if (!match.matched) continue;
                if (match.direct) direct++;
                else similar++;
                filtered.push({
                    ...song,
                    searchScore: match.score,
                    searchMatchKind: match.direct ? 'direct' : 'similar'
                });
                continue;
            }

            filtered.push(song);
        }

        this.searchSummary = {
            query: this.searchText.trim(),
            total: filtered.length,
            direct,
            similar
        };
        return filtered;
    }

    public hasSearchQuery(): boolean {
        return !!this.normalizeSearch(this.searchText);
    }

    public onSearchInput() {
        this.refreshView();
    }

    public onSearchKeydown(event: KeyboardEvent) {
        if (event.key !== 'Escape' || !this.searchText) return;
        event.preventDefault();
        this.searchText = '';
        this.refreshView();
    }

    private normalizeSearch(value: any): string {
        const raw = String(value || '');
        const daggerAlias = /[\u2020\u2021†]/.test(raw) ? ' leggendaria ' : '';
        return this.foldScoreTitleText(`${raw}${daggerAlias}`)
            .toLowerCase()
            .replace(/[_\-~〜～–—－/]+/g, ' ')
            .replace(/[\p{P}\p{S}]+/gu, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    private compactSearch(value: any): string {
        return this.normalizeSearch(value).replace(/\s+/g, '');
    }

    private uniqueSearchStrings(values: any[]): string[] {
        const seen: any = {};
        const output: string[] = [];
        for (const value of values) {
            const text = String(value || '').trim();
            if (!text || seen[text]) continue;
            seen[text] = true;
            output.push(text);
        }
        return output;
    }

    private getExpandedSearchTerms(query: string): string[] {
        const baseTerms = query.split(/\s+/).filter((term) => !!term);
        const aliases: string[][] = [
            ['스크래치', '스크', 'scratch', '皿', 'sar'],
            ['변속', '소프란', 'soflan', 'bpm', '속도변화', '속도 변화', 'ソフラン'],
            ['트릴', 'trill', '交互', '교대'],
            ['계단', 'stair', 'stairs', '階段'],
            ['동시치기', '동시', '동치', 'chord', 'chords', '同時押し'],
            ['차지', '차지노트', 'charge', 'cn', 'bss', 'チャージ'],
            ['연타', '연타곡', 'rapid', 'jack', '縦連'],
            ['발광', '폭타', '난타', 'density', 'stream', '乱打'],
            ['개인차', 'id', 'individual', '개차'],
            ['지력', 'ep', '종합', 'overall'],
            ['레겐다리아', 'leggendaria', 'legendaria', 'leggen', '†', 'spl', 'dpl'],
            ['어나더', 'another', 'spa', 'dpa'],
            ['하이퍼', 'hyper', 'sph', 'dph'],
            ['노멀', 'normal', 'spn', 'dpn'],
            ['싱글', 'single', 'sp'],
            ['더블', 'double', 'dp']
        ].map((group) => group.map((term) => this.normalizeSearch(term)).filter((term) => !!term));

        const expanded = [...baseTerms];
        for (const term of baseTerms) {
            for (const group of aliases) {
                if (!group.some((alias) => alias === term || (term.length > 1 && alias.includes(term)) || (alias.length > 1 && term.includes(alias)))) continue;
                expanded.push(...group);
            }
        }
        return this.uniqueSearchStrings(expanded);
    }

    private getSongSearchFields(song: any): string[] {
        const tagEvidence = song && song.tagEvidence || {};
        const tags = [
            song && song.primaryTag,
            ...(Array.isArray(song && song.secondaryTags) ? song.secondaryTags : []),
            ...(Array.isArray(song && song.sourceTags) ? song.sourceTags : []),
            ...(Array.isArray(tagEvidence && tagEvidence.sourceTags) ? tagEvidence.sourceTags : [])
        ];
        const chartType = this.getChartType(song && song.difficulty, song && song.playStyle);
        const bpmLabel = this.getWeeklyBpmLabel(song);
        return this.uniqueSearchStrings([
            song && song.title,
            song && song.textageTitle,
            song && song.displayTitle,
            song && song.songKey,
            song && song.id,
            song && song.difficulty,
            this.getDifficultyFilterLabel(song && song.difficulty),
            chartType,
            song && song.playStyle,
            this.getPlayStyleLabel(),
            song && song.level ? `level ${song.level}` : '',
            song && song.level ? `${song.level}레벨` : '',
            song && song.level ? `☆${song.level}` : '',
            song && song.version,
            song && song.versionLabel,
            song && song.memo,
            song && song.tier,
            song && song.tierRaw,
            song && song.hardTier,
            song && song.hardRaw,
            song && song.normalTier,
            song && song.normalRaw,
            song && song.epTier,
            song && song.epRaw,
            song && song.idTier,
            song && song.idRaw,
            song && song.bpm,
            song && song.bpmText,
            song && song.bpmBand,
            bpmLabel,
            song && song.noteCount ? `${song.noteCount}노트` : '',
            song && song.noteCount ? `${song.noteCount} notes` : '',
            ...(tags || [])
        ]);
    }

    private getCharacterNgrams(value: string, size: number = 2): string[] {
        const compact = this.compactSearch(value);
        if (!compact) return [];
        if (compact.length <= size) return [compact];
        const grams: string[] = [];
        for (let index = 0; index <= compact.length - size; index++) {
            grams.push(compact.slice(index, index + size));
        }
        return grams;
    }

    private diceSimilarity(left: string, right: string): number {
        const leftGrams = this.getCharacterNgrams(left);
        const rightGrams = this.getCharacterNgrams(right);
        if (!leftGrams.length || !rightGrams.length) return 0;

        const counts: any = {};
        for (const gram of leftGrams) counts[gram] = (counts[gram] || 0) + 1;
        let overlap = 0;
        for (const gram of rightGrams) {
            if (!counts[gram]) continue;
            counts[gram]--;
            overlap++;
        }
        return (2 * overlap) / (leftGrams.length + rightGrams.length);
    }

    private levenshteinSimilarity(left: string, right: string): number {
        const a = this.compactSearch(left);
        const b = this.compactSearch(right);
        if (!a || !b) return 0;
        if (a === b) return 1;
        const maxLength = Math.max(a.length, b.length);
        if (!maxLength) return 1;

        const previous: number[] = [];
        const current: number[] = [];
        for (let j = 0; j <= b.length; j++) previous[j] = j;
        for (let i = 1; i <= a.length; i++) {
            current[0] = i;
            for (let j = 1; j <= b.length; j++) {
                const cost = a[i - 1] === b[j - 1] ? 0 : 1;
                current[j] = Math.min(
                    current[j - 1] + 1,
                    previous[j] + 1,
                    previous[j - 1] + cost
                );
            }
            for (let j = 0; j <= b.length; j++) previous[j] = current[j];
        }
        return 1 - previous[b.length] / maxLength;
    }

    private tokenSimilarity(queryTerms: string[], field: string): number {
        const fieldText = this.normalizeSearch(field);
        if (!fieldText || !queryTerms.length) return 0;
        let hits = 0;
        for (const term of queryTerms) {
            if (!term) continue;
            if (fieldText.includes(term) || this.diceSimilarity(term, fieldText) >= 0.72) hits++;
        }
        return hits / queryTerms.length;
    }

    private scoreSongSearch(song: any, query: string) {
        const compactQuery = this.compactSearch(query);
        if (!query || !compactQuery) return { matched: true, direct: true, score: 1 };

        const fields = this.getSongSearchFields(song);
        const normalizedFields = fields
            .map((field) => ({
                raw: String(field || ''),
                text: this.normalizeSearch(field),
                compact: this.compactSearch(field)
            }))
            .filter((field) => !!field.text || !!field.compact);
        const shortQuery = compactQuery.length <= 2;
        const baseTerms = query.split(/\s+/).filter((term) => !!term);
        const terms = this.getExpandedSearchTerms(query);

        let bestScore = 0;
        let direct = false;
        let semanticAlias = false;

        for (const field of normalizedFields) {
            if (!field.text && !field.compact) continue;
            if (field.text === query || field.compact === compactQuery) {
                bestScore = Math.max(bestScore, 1);
                direct = true;
                continue;
            }
            if (!shortQuery && (field.text.includes(query) || field.compact.includes(compactQuery))) {
                const ratio = Math.min(compactQuery.length, field.compact.length) / Math.max(compactQuery.length, field.compact.length);
                bestScore = Math.max(bestScore, 0.82 + ratio * 0.12);
                direct = true;
            }
            if (baseTerms.length > 1 && baseTerms.every((term) => field.text.includes(term) || field.compact.includes(this.compactSearch(term)))) {
                bestScore = Math.max(bestScore, 0.88);
                direct = true;
            }
            if (terms.some((term) => {
                const termCompact = this.compactSearch(term);
                const aliasLike = termCompact !== compactQuery || /[가-힣ぁ-んァ-ン一-龯皿]/.test(term);
                return term.length > 1 && aliasLike && (field.text.includes(term) || field.compact.includes(termCompact));
            })) {
                bestScore = Math.max(bestScore, 0.76);
                if (!direct) semanticAlias = true;
            }
        }

        const titleFields = this.uniqueSearchStrings([
            song && song.title,
            song && song.textageTitle,
            song && song.displayTitle
        ]);
        for (const title of titleFields) {
            bestScore = Math.max(
                bestScore,
                this.diceSimilarity(query, title) * 0.82,
                this.levenshteinSimilarity(query, title) * 0.74,
                this.tokenSimilarity(terms, title) * 0.86
            );
        }

        for (const field of normalizedFields) {
            bestScore = Math.max(bestScore, this.tokenSimilarity(terms, field.raw) * 0.72);
        }

        const matched = direct || semanticAlias || (!shortQuery && bestScore >= this.similarSearchThreshold);
        return {
            matched,
            direct,
            score: bestScore
        };
    }

    private hasClassificationFor(song: any, classification: 'ep' | 'id'): boolean {
        return this.getSongTierFor(song, classification) !== '미분류';
    }

    public selectTier(tier: string) {
        this.selectTableTab(tier);
    }

    public clearFilters() {
        this.tableMode = 'tier';
        this.selectedTiers = [];
        this.selectedLevelGroup = 'all';
        this.selectedLevel = 'all';
        this.selectedDifficulty = 'all';
        this.selectedVersion = 'all';
        this.searchText = '';
        this.refreshView();
    }

    public hasActiveFilters(): boolean {
        const directMode = this.isDirectTierMode();
        return (!directMode && this.selectedTiers.length > 0)
            || (directMode && this.selectedLevelGroup !== 'all')
            || (!directMode && this.selectedLevel !== 'all')
            || this.selectedDifficulty !== 'all'
            || this.selectedVersion !== 'all'
            || !!this.searchText.trim();
    }

    private getSongTierFor(song: any, classification: 'ep' | 'id'): string {
        return classification === 'id'
            ? this.normalizeTier(song.idTier)
            : this.normalizeTier(song.epTier);
    }

    public getSongDisplayTitle(song: any): string {
        return song.title || '제목 준비중';
    }

    public showTitleTooltip(title: any, event: any) {
        const text = String(title || '').trim();
        if (!text || !event || !event.currentTarget) return;

        const rect = event.currentTarget.getBoundingClientRect();
        const maxWidth = Math.min(420, Math.max(180, window.innerWidth - 16));
        const minLeft = (maxWidth / 2) + 8;
        const maxLeft = window.innerWidth - minLeft;
        const center = rect.left + rect.width / 2;
        const placement = rect.top < 64 ? 'below' : 'above';
        this.titleTooltip = {
            visible: true,
            text,
            left: Math.min(Math.max(center, minLeft), maxLeft),
            top: placement === 'below' ? rect.bottom + 8 : rect.top - 8,
            placement
        };
        this.service.render();
    }

    public hideTitleTooltip() {
        if (!this.titleTooltip.visible) return;
        this.titleTooltip = { visible: false, text: '', left: 0, top: 0, placement: 'above' };
        this.service.render();
    }

    public isLeggendaria(song: any): boolean {
        return this.isLeggendariaDifficulty(song && song.difficulty);
    }

    public isHyper(song: any): boolean {
        const normalized = String(song && song.difficulty || '').trim().toUpperCase();
        return normalized === 'HYPER' || normalized === 'H';
    }

    public getDifficultyMark(song: any): string {
        if (this.isLeggendaria(song)) return '†';
        if (this.isHyper(song)) return 'H';
        return '';
    }

    public getDifficultyFilterLabel(difficulty: string): string {
        const normalized = String(difficulty || '').toUpperCase();
        if (normalized === 'LEGGENDARIA') return '†';
        if (normalized === 'HYPER') return 'HYPER';
        if (normalized === 'ANOTHER') return 'ANOTHER';
        if (normalized === 'NORMAL') return 'NORMAL';
        return difficulty;
    }

    private getNumericTierPalette(tier: string) {
        const value = Number(tier);
        if (Number.isNaN(value)) return null;
        if (value >= 12.4) return { bg: '#ffffff', fg: '#18181b', accent: '#52525b' };
        if (value >= 12.0) return { bg: '#ffffff', fg: '#27272a', accent: '#71717a' };
        if (value >= 11.0) return { bg: '#ffffff', fg: '#3f3f46', accent: '#a1a1aa' };
        return { bg: '#ffffff', fg: '#52525b', accent: '#a1a1aa' };
    }

    public getTierBackground(tier: string): string {
        return (this.tierPalette[tier] || this.getNumericTierPalette(tier) || this.tierPalette['미분류']).bg;
    }

    public getTierTextColor(tier: string): string {
        return (this.tierPalette[tier] || this.getNumericTierPalette(tier) || this.tierPalette['미분류']).fg;
    }

    public getTierAccent(tier: string): string {
        return (this.tierPalette[tier] || this.getNumericTierPalette(tier) || this.tierPalette['미분류']).accent;
    }

    public getDifficultyClass(difficulty: string): string {
        if (difficulty === 'LEGGENDARIA') {
            return 'border-rose-500/40 bg-rose-500/10 text-rose-200';
        }
        if (difficulty === 'ANOTHER') {
            return 'border-cyan-500/40 bg-cyan-500/10 text-cyan-200';
        }
        return 'border-zinc-600 bg-zinc-800 text-zinc-300';
    }

    public getYoutubeQuery(song: any): string {
        return this.buildYoutubeQuery(song && song.title, song && song.difficulty, song && song.playStyle);
    }

    public getYoutubeUrl(song: any): string {
        const query = this.getYoutubeQuery(song).trim();
        if (!query) return '';
        return `${YOUTUBE_SEARCH_URL}?search_query=${encodeURIComponent(query)}`;
    }

    public isYoutubeReady(song: any): boolean {
        return !!this.getYoutubeUrl(song);
    }

    public getTextageUrl(song: any): string {
        const url = String(song && song.textageUrl || '').trim();
        return url.startsWith('https://textage.cc/score/') ? url : '';
    }

    public isTextageReady(song: any): boolean {
        return !!this.getTextageUrl(song);
    }

    public openTextage(song: any, event: Event) {
        event.preventDefault();
        event.stopPropagation();
        const url = this.getTextageUrl(song);
        if (!url) return;
        window.open(url, '_blank', 'noopener');
    }

    private redirectYoutubeWindow(youtubeWindow: Window, url: string) {
        try {
            if (!youtubeWindow.closed) {
                youtubeWindow.location.replace(url);
            }
        } catch {
            try {
                youtubeWindow.location.href = url;
            } catch { }
        }
    }

    public async openYoutube(song: any, event: Event) {
        event.preventDefault();
        event.stopPropagation();
        const query = this.getYoutubeQuery(song).trim();
        const fallbackUrl = this.getYoutubeUrl(song);
        if (!query || !fallbackUrl) return;

        const youtubeWindow = window.open('about:blank', '_blank');
        if (!youtubeWindow) {
            window.open(fallbackUrl, '_blank');
            return;
        }

        try {
            youtubeWindow.document.title = 'YouTube';
            if (youtubeWindow.document.body) {
                youtubeWindow.document.body.textContent = 'YouTube로 이동 중...';
            }
        } catch { }

        try {
            const { code, data } = await wiz.call("youtube_search", { query });
            const url = code === 200 && data && data.url ? data.url : fallbackUrl;
            this.redirectYoutubeWindow(youtubeWindow, url);
        } catch {
            this.redirectYoutubeWindow(youtubeWindow, fallbackUrl);
        }
    }

    private async canvasToPngBlob(canvas: HTMLCanvasElement): Promise<Blob> {
        return await new Promise<Blob>((resolve, reject) => {
            if (canvas.toBlob) {
                canvas.toBlob((blob) => {
                    if (blob && blob.size > 0) {
                        resolve(blob);
                    } else {
                        reject(new Error('PNG 생성 실패'));
                    }
                }, 'image/png');
                return;
            }

            const dataUrl = canvas.toDataURL('image/png');
            if (!dataUrl || dataUrl === 'data:,') {
                reject(new Error('PNG 생성 실패'));
                return;
            }

            const parts = dataUrl.split(',');
            const binary = atob(parts[1]);
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            resolve(new Blob([bytes], { type: 'image/png' }));
        });
    }

    private async downloadCanvasAsPng(canvas: HTMLCanvasElement, filename: string) {
        const blob = await this.canvasToPngBlob(canvas);
        const nav = window.navigator as any;
        if (nav.msSaveOrOpenBlob) {
            nav.msSaveOrOpenBlob(blob, filename);
            return;
        }

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.rel = 'noopener';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    private drawExportText(ctx: CanvasRenderingContext2D, text: string, x: number, y: number, maxW: number) {
        let value = String(text || '');
        if (ctx.measureText(value).width <= maxW) {
            ctx.fillText(value, x, y);
            return;
        }
        while (value.length > 0 && ctx.measureText(value + '...').width > maxW) {
            value = value.slice(0, -1);
        }
        ctx.fillText(value + '...', x, y);
    }

    private fillExportRoundRect(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number, fill: string) {
        const radius = Math.min(r, w / 2, h / 2);
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + w - radius, y);
        ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
        ctx.lineTo(x + w, y + h - radius);
        ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);
        ctx.lineTo(x + radius, y + h);
        ctx.quadraticCurveTo(x, y + h, x, y + h - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        ctx.fillStyle = fill;
        ctx.fill();
    }

    private getExportLampColor(record: any): string {
        const key = this.getLampProgressKey(record);
        switch (key) {
            case 'failed': return '#f87171';
            case 'assist': return '#c084fc';
            case 'easy': return '#bef264';
            case 'normal': return '#2563eb';
            case 'hard': return '#ffffff';
            case 'ex-hard': return '#fde047';
            case 'full-combo': return '#7dd3fc';
            default: return '';
        }
    }

    private getExportClearLabel(record: any): string {
        if (!this.hasIidxAttemptRecord(record)) return '';
        const value = this.getNormalizedClearType(record);
        if (value.includes('F-COMBO') || value.includes('FULL-COMBO') || value.includes('FULLCOMBO')) return 'FC';
        if (value.includes('EXH') || value.includes('EX-HARD') || value.includes('EX-H-CLEAR')) return 'EXH';
        if (value.includes('H-CLEAR') || value.includes('HARD')) return 'HARD';
        if (value.includes('A-CLEAR') || value.includes('ASSIST')) return 'ASSIST';
        if (value.includes('E-CLEAR') || value.includes('EASY')) return 'EASY';
        if (value.includes('CLEAR') || value.includes('NORMAL')) return 'CLEAR';
        if (value.includes('FAILED') || value.includes('FAIL')) return 'FAILED';
        return 'PLAY';
    }

    private getExportScopeLabel(): string {
        if (this.isDirectTierMode()) {
            if (this.selectedLevelGroup === 'all') return '전체';
            if (this.selectedLevelGroup === 'other') return '기타';
            return `☆${this.selectedLevelGroup}`;
        }
        return this.selectedLevel === 'all' ? '전체 레벨' : `☆${this.selectedLevel}`;
    }

    public async exportChart() {
        if (this.exportingChart) return;
        this.exportingChart = true;
        await this.service.render();

        try {
            await ((document as any).fonts?.ready || Promise.resolve());
            await this.loadUpdateStatus(false, false);
            const dark = this.themeMode === 'dark';
            const CW = 1440;
            const margin = 40;
            const labelW = 132;
            const rowGap = 6;
            const cols = 6;
            const cardGap = 0;
            const contentW = CW - (margin * 2);
            const gridW = contentW - labelW - rowGap;
            const cardW = Math.floor((gridW - (cardGap * (cols - 1))) / cols);
            const cardH = 62;
            const headerH = 144;
            const footerH = 54;
            const sectionGap = 7;
            const fontFamily = 'SUIT, "Noto Sans KR", "Noto Sans JP", Arial, sans-serif';
            const visibleSections = (this.sections || []).filter((section: any) => section && Array.isArray(section.songs));

            let totalH = headerH + footerH;
            for (const section of visibleSections) {
                const rows = Math.max(1, Math.ceil(section.songs.length / cols));
                totalH += Math.max(54, rows * cardH + (rows - 1) * cardGap) + sectionGap;
            }

            const maxCanvasSide = 16000;
            const maxCanvasArea = 16000000;
            const exportScale = Math.min(
                1,
                maxCanvasSide / Math.max(CW, totalH),
                Math.sqrt(maxCanvasArea / (CW * totalH))
            );

            const canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.floor(CW * exportScale));
            canvas.height = Math.max(1, Math.floor(totalH * exportScale));
            const ctx = canvas.getContext('2d');
            if (!ctx) throw new Error('Canvas 생성 실패');
            ctx.scale(exportScale, exportScale);
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';

            const bg = dark ? '#09090b' : '#f4f4f5';
            const panel = dark ? '#18181b' : '#ffffff';
            const border = dark ? '#52525b' : '#a1a1aa';
            const cellBorder = dark ? '#3f3f46' : '#d4d4d8';
            const text = dark ? '#f4f4f5' : '#18181b';
            const muted = dark ? '#a1a1aa' : '#71717a';
            const scoreColor = dark ? '#67e8f9' : '#155e75';
            const scopeLabel = this.getExportScopeLabel();

            ctx.fillStyle = bg;
            ctx.fillRect(0, 0, CW, totalH);
            this.fillExportRoundRect(ctx, margin, 24, contentW, 96, 4, panel);
            ctx.strokeStyle = border;
            ctx.strokeRect(margin + 0.5, 24.5, contentW - 1, 95);
            ctx.fillStyle = text;
            ctx.font = `800 30px ${fontFamily}`;
            this.drawExportText(ctx, this.tableTitle || 'beatmania IIDX 서열표', margin + 24, 65, contentW - 48);
            ctx.fillStyle = muted;
            ctx.font = `600 15px ${fontFamily}`;
            const progressText = this.progressStats.total > 0
                ? `표시 ${this.stats.visible}곡 · 플레이 ${this.progressStats.played}/${this.progressStats.total} · 스코어 ${this.progressStats.scored}/${this.progressStats.total}`
                : `표시 ${this.stats.visible}곡`;
            ctx.fillText(`${this.getPlayStyleLabel()} · ${scopeLabel} · ${this.getSortModeLabel()} · ${progressText}`, margin + 24, 94);

            let y = headerH;
            for (const section of visibleSections) {
                const rows = Math.max(1, Math.ceil(section.songs.length / cols));
                const sectionH = Math.max(54, rows * cardH + (rows - 1) * cardGap);
                const labelFill = dark ? '#000000' : (section.backgroundColor || '#ffffff');
                const labelText = dark ? '#f4f4f5' : (section.color || '#18181b');

                this.fillExportRoundRect(ctx, margin, y, labelW, sectionH, 0, labelFill);
                ctx.strokeStyle = border;
                ctx.strokeRect(margin + 0.5, y + 0.5, labelW - 1, sectionH - 1);
                ctx.fillStyle = labelText;
                ctx.font = `800 16px ${fontFamily}`;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(String(section.label || section.name || '미분류'), margin + labelW / 2, y + sectionH / 2 - 7);
                ctx.font = `700 11px ${fontFamily}`;
                ctx.fillText(`${section.songs.length}곡`, margin + labelW / 2, y + sectionH / 2 + 15);
                ctx.textAlign = 'left';
                ctx.textBaseline = 'alphabetic';

                section.songs.forEach((song: any, index: number) => {
                    const col = index % cols;
                    const row = Math.floor(index / cols);
                    const x = margin + labelW + rowGap + col * (cardW + cardGap);
                    const cy = y + row * (cardH + cardGap);
                    const record = this.getVisibleSongRecord(song);
                    const lampColor = this.getExportLampColor(record);

                    ctx.fillStyle = panel;
                    ctx.fillRect(x, cy, cardW, cardH);
                    if (lampColor) {
                        ctx.fillStyle = lampColor;
                        ctx.fillRect(x, cy, 7, cardH);
                        if (this.getLampProgressKey(record) === 'hard' && dark) {
                            ctx.fillStyle = '#71717a';
                            ctx.fillRect(x + 6, cy, 1, cardH);
                        }
                    }
                    ctx.strokeStyle = cellBorder;
                    ctx.strokeRect(x + 0.5, cy + 0.5, cardW - 1, cardH - 1);

                    const mark = this.getDifficultyMark(song);
                    if (mark) {
                        ctx.font = `800 ${mark === '†' ? 13 : 11}px ${fontFamily}`;
                        ctx.fillStyle = mark === '†' ? (dark ? '#c084fc' : '#be123c') : (dark ? '#67e8f9' : '#0e7490');
                        ctx.fillText(mark, x + 14, cy + 20);
                    }

                    ctx.font = `700 12px ${fontFamily}`;
                    ctx.fillStyle = text;
                    this.drawExportText(ctx, this.getSongDisplayTitle(song), x + (mark ? 32 : 14), cy + 20, cardW - (mark ? 44 : 26));

                    ctx.font = `500 10px ${fontFamily}`;
                    ctx.fillStyle = muted;
                    const meta = `${this.levels.length > 1 ? `☆${song.level} · ` : ''}${song.versionLabel || ''}`;
                    this.drawExportText(ctx, meta, x + 14, cy + 39, cardW - 28);

                    if (record) {
                        const clearLabel = this.getExportClearLabel(record);
                        let recordX = x + 14;
                        if (clearLabel) {
                            ctx.font = `700 9px ${fontFamily}`;
                            const badgeW = Math.ceil(ctx.measureText(clearLabel).width) + 12;
                            this.fillExportRoundRect(ctx, recordX, cy + 44, badgeW, 14, 2, lampColor || (dark ? '#27272a' : '#f4f4f5'));
                            ctx.strokeStyle = cellBorder;
                            ctx.strokeRect(recordX + 0.5, cy + 44.5, badgeW - 1, 13);
                            ctx.fillStyle = '#18181b';
                            ctx.fillText(clearLabel, recordX + 6, cy + 55);
                            recordX += badgeW + 6;
                        }
                        ctx.font = `600 10px ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace`;
                        ctx.fillStyle = scoreColor;
                        const rank = this.shouldShowIidxRankLabel(song, record) ? ` ${this.getRankLabel(record.rank)}` : '';
                        this.drawExportText(ctx, `${this.formatIidxScore(song, record)}${rank}`, recordX, cy + 55, x + cardW - recordX - 12);
                    }
                });

                y += sectionH + sectionGap;
            }

            ctx.fillStyle = muted;
            ctx.font = `500 13px ${fontFamily}`;
            ctx.textAlign = 'center';
            ctx.fillText('서열표 데이터 출처: beatmania IIDX unofficial rank table', CW / 2, totalH - 28);

            const d = new Date();
            const ds = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
            const fileScope = scopeLabel.replace(/\s+/g, '');
            await this.downloadCanvasAsPng(canvas, `iidx서열표_${this.getPlayStyleLabel()}_${fileScope}_${ds}.png`);
        } catch (e) {
            console.error('Export failed:', e);
            const msg = e instanceof Error ? e.message : String(e);
            alert('이미지 저장 실패: ' + msg);
        } finally {
            this.exportingChart = false;
            await this.service.render();
        }
    }

    public openUpdateModal() {
        this.updateModalOpen = true;
        this.loadUpdateStatus(false);
        this.service.render();
    }

    public closeUpdateModal() {
        this.updateModalOpen = false;
        this.service.render();
    }

    public openRecordModal(song: any, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.hideTitleTooltip();
        const current = this.getSongRecord(song) || {};
        const noteCount = Number((song && song.noteCount) || current.noteCount || current.note_count || 0);
        const score = this.normalizeIidxScoreValue(current.score, noteCount);
        this.recordEditSong = song;
        this.recordEditScore = score > 0 ? String(score) : '';
        this.recordEditClearType = this.normalizeManualClearType(current.clear_type || current.clearType);
        this.recordEditError = '';
        this.recordSaving = false;
        this.recordModalOpen = true;
        this.service.render();
    }

    public closeRecordModal() {
        if (this.recordSaving) return;
        this.recordModalOpen = false;
        this.recordEditSong = null;
        this.recordEditError = '';
        this.service.render();
    }

    public resetManualRecordForm() {
        this.recordEditScore = '';
        this.recordEditClearType = 'NO PLAY';
        this.recordEditError = '';
        this.service.render();
    }

    public getRecordModalSubtitle(): string {
        if (!this.recordEditSong) return '';
        const title = this.getSongDisplayTitle(this.recordEditSong);
        const difficulty = this.getDifficultyFilterLabel(this.recordEditSong.difficulty);
        return `${this.recordEditSong.playStyle || this.tablePlayStyle} ${difficulty} · ${title}`;
    }

    public getRecordScoreMax(): number {
        const noteCount = Number(this.recordEditSong && this.recordEditSong.noteCount || 0);
        return noteCount > 0 ? noteCount * 2 : 20000;
    }

    public getRecordScoreMaxLabel(): string {
        const noteCount = Number(this.recordEditSong && this.recordEditSong.noteCount || 0);
        if (noteCount > 0) return `최대 ${this.getRecordScoreMax().toLocaleString()}점`;
        return '0 이상 숫자';
    }

    private normalizeManualClearType(value: any): string {
        const normalized = this.getNormalizedClearType({ clear_type: value });
        if (this.isNoPlayClearType(normalized)) return 'NO PLAY';
        if (normalized.includes('F-COMBO') || normalized.includes('FULL-COMBO') || normalized.includes('FULLCOMBO')) return 'F-COMBO';
        if (normalized.includes('EXH') || normalized.includes('EX-HARD') || normalized.includes('EX-H-CLEAR')) return 'EXH-CLEAR';
        if (normalized.includes('H-CLEAR') || normalized.includes('HARD')) return 'H-CLEAR';
        if (normalized.includes('A-CLEAR') || normalized.includes('ASSIST')) return 'A-CLEAR';
        if (normalized.includes('E-CLEAR') || normalized.includes('EASY')) return 'E-CLEAR';
        if (normalized.includes('FAILED') || normalized.includes('FAIL')) return 'FAILED';
        if (normalized.includes('CLEAR') || normalized.includes('NORMAL')) return 'CLEAR';
        return 'NO PLAY';
    }

    private parseManualScore(value: any): number | null {
        const raw = String(value || '').replace(/,/g, '').trim();
        if (!raw) return 0;
        const numeric = Number(raw);
        if (!Number.isFinite(numeric) || numeric < 0 || Math.floor(numeric) !== numeric) return null;
        return Math.min(numeric, this.getRecordScoreMax());
    }

    private getManualRankFromScore(score: number, noteCount: number): string {
        const maxScore = noteCount > 0 ? noteCount * 2 : 0;
        if (score <= 0 || maxScore <= 0) return '';
        if (score >= maxScore) return 'MAX';
        const levels = [
            { label: 'AAA', threshold: this.iidxScoreBorder(maxScore, 8) },
            { label: 'AA', threshold: this.iidxScoreBorder(maxScore, 7) },
            { label: 'A', threshold: this.iidxScoreBorder(maxScore, 6) },
            { label: 'B', threshold: this.iidxScoreBorder(maxScore, 5) },
            { label: 'C', threshold: this.iidxScoreBorder(maxScore, 4) },
            { label: 'D', threshold: this.iidxScoreBorder(maxScore, 3) },
            { label: 'E', threshold: this.iidxScoreBorder(maxScore, 2) }
        ];
        for (const item of levels) {
            if (score >= item.threshold) return item.label;
        }
        return 'F';
    }

    private buildManualIidxRecord(): any | null {
        const song = this.recordEditSong || {};
        const musicName = String(song.title || '').trim();
        const difficulty = this.normalizeScoreDifficulty(song.difficulty);
        const score = this.parseManualScore(this.recordEditScore);
        if (!musicName || !difficulty) {
            this.recordEditError = '곡 정보를 확인하지 못했습니다.';
            return null;
        }
        if (score === null) {
            this.recordEditError = '스코어는 0 이상의 정수로 입력해주세요.';
            return null;
        }

        const noteCount = Number(song.noteCount || 0);
        const playType = this.normalizePlayType(song.playStyle, this.tablePlayStyle);
        return {
            music_name: musicName,
            difficulty,
            level: Number(song.level || 0),
            rank: this.getManualRankFromScore(score, noteCount),
            score,
            clear_type: this.normalizeManualClearType(this.recordEditClearType),
            play_type: playType,
            noteCount,
            note_count: noteCount,
            source: 'manual-entry'
        };
    }

    private applyManualIidxRecordToCurrentMap(record: any) {
        const normalized = this.normalizeScoreRecord(record, this.tablePlayStyle);
        for (const key of this.makeRecordScoreKeys(normalized)) {
            this.latestScoreMap[key] = normalized;
        }
    }

    private saveManualIidxRecordLocally(record: any) {
        const playStyle = this.normalizePlayType(record && (record.play_type || record.playType), this.tablePlayStyle);
        const normalized = this.normalizeScoreRecord(record, playStyle);
        const map = this.loadLocalIidxScoreMap(playStyle);
        for (const key of this.makeRecordScoreKeys(normalized)) {
            map[key] = normalized;
        }
        this.saveLocalIidxScoreMap(map, playStyle);
    }

    public async saveManualRecord() {
        if (this.recordSaving) return;
        const record = this.buildManualIidxRecord();
        if (!record) {
            await this.service.render();
            return;
        }

        this.recordSaving = true;
        this.recordEditError = '';
        await this.service.render();

        try {
            if (this.updateInfo && this.updateInfo.loggedIn) {
                const { code, data } = await wiz.call("save_manual_scores", {
                    records: JSON.stringify([record]),
                    _ts: Date.now()
                });
                if (code !== 200) {
                    throw new Error(data?.message || 'DB 저장에 실패했습니다.');
                }
                this.applyManualIidxRecordToCurrentMap(record);
                this.refreshView();
                this.recordModalOpen = false;
                this.recordEditSong = null;
                await this.loadUpdateStatus(false, true);
            } else {
                this.saveManualIidxRecordLocally(record);
                this.applyManualIidxRecordToCurrentMap(record);
                this.refreshView();
                this.recordModalOpen = false;
                this.recordEditSong = null;
            }
        } catch (error: any) {
            this.recordEditError = error && error.message ? error.message : '기록 저장에 실패했습니다.';
        } finally {
            this.recordSaving = false;
            await this.service.render();
        }
    }

    private getLocalIidxScoreStorageKey(playStyle: PlayStyle = this.tablePlayStyle): string {
        return `${IIDX_LOCAL_SCORE_STORAGE_KEY}:${playStyle}`;
    }

    private loadLocalIidxScoreMap(playStyle: PlayStyle = this.tablePlayStyle): any {
        try {
            const raw = localStorage.getItem(this.getLocalIidxScoreStorageKey(playStyle));
            const parsed = raw ? JSON.parse(raw) : {};
            return parsed && typeof parsed === 'object' ? parsed : {};
        } catch {
            return {};
        }
    }

    private saveLocalIidxScoreMap(map: any, playStyle: PlayStyle = this.tablePlayStyle) {
        try {
            localStorage.setItem(this.getLocalIidxScoreStorageKey(playStyle), JSON.stringify(map || {}));
        } catch { }
    }

    private jsStringLiteral(value: string): string {
        return JSON.stringify(String(value || ''));
    }

    private buildBookmarkletCode(token: string = this.updateToken, autoStart: boolean = !!this.updateToken): string {
        const origin = window.location.origin.replace(/\/$/, '');
        const commands = [
            `window.__TAIGO_IIDX_ORIGIN=${this.jsStringLiteral(origin)}`,
            token ? `window.__TAIGO_IIDX_TOKEN=${this.jsStringLiteral(token)}` : '',
            `window.__TAIGO_IIDX_AUTO_START=${autoStart && !!token ? 'true' : 'false'}`,
            'window.__TAIGO_IIDX_AUTO_CLOSE=true',
            'var s=document.createElement("script")',
            's.src=window.__TAIGO_IIDX_ORIGIN+"/assets/iidx-updater.js?ts="+Date.now()',
            '(document.head||document.documentElement).appendChild(s)'
        ].filter(Boolean);
        return `javascript:(function(){${commands.join(';')};})()`;
    }

    private updateBookmarkletCode() {
        this.bookmarkletCode = this.buildBookmarkletCode();
    }

    private async requestUpdateToken(): Promise<boolean> {
        this.updateBaselineUpdatedAt = this.latestUpdatedMillis();
        try {
            const { code, data } = await wiz.call("generate_update_token", { _ts: Date.now() });
            if (code === 200 && data) {
                this.updateToken = data.token || '';
                this.updateTokenExpires = data.expires || '';
                this.updateBookmarkletCode();
                this.updateStatusMessage = '토큰을 발급했습니다.';
                this.startUpdateStatusPolling();
                return true;
            }
            this.updateStatusMessage = data?.message || '토큰 발급에 실패했습니다.';
        } catch {
            this.updateStatusMessage = '토큰 발급에 실패했습니다.';
        }
        return false;
    }

    private focusUpdateScriptWindow(popup: Window | null, focus: boolean = true) {
        if (!popup) return;
        this.updateScriptWindow = popup;
        this.updateSessionWindowOpened = true;
        if (!focus) return;
        try {
            popup.focus();
        } catch { }
    }

    private openEamusementSessionWindow(url: string = IIDX_EAGATE_STATUS_URL): Window | null {
        const popup = window.open(url, IIDX_EAGATE_WINDOW_NAME, IIDX_EAGATE_WINDOW_FEATURES);
        this.focusUpdateScriptWindow(popup);
        return popup;
    }

    private getUpdateSessionWindowForExecution(): { popup: Window | null; ready: boolean } {
        if (this.updateScriptWindow && !this.updateScriptWindow.closed) {
            try {
                const href = this.updateScriptWindow.location.href;
                if (href === 'about:blank' || !href.startsWith('https://p.eagate.573.jp/')) {
                    this.updateScriptWindow.location.replace(IIDX_EAGATE_STATUS_URL);
                    this.focusUpdateScriptWindow(this.updateScriptWindow);
                    return { popup: this.updateScriptWindow, ready: false };
                }
            } catch {
                return { popup: this.updateScriptWindow, ready: true };
            }
            return { popup: this.updateScriptWindow, ready: true };
        }

        const popup = window.open(IIDX_EAGATE_STATUS_URL, IIDX_EAGATE_WINDOW_NAME, IIDX_EAGATE_WINDOW_FEATURES);
        if (!popup) return { popup: null, ready: false };
        this.focusUpdateScriptWindow(popup);
        return { popup, ready: false };
    }

    private async ensureUpdateToken(): Promise<boolean> {
        if (this.updateToken) {
            this.updateBookmarkletCode();
            return true;
        }
        return await this.requestUpdateToken();
    }

    private async copyUpdateScriptForFallback(): Promise<boolean> {
        this.updateBookmarkletCode();
        const copied = await this.writeClipboardText(this.bookmarkletCode);
        if (copied) this.markCopiedTarget('bookmarklet');
        return copied;
    }

    private requestUpdateScriptExecution(): boolean {
        this.updateBookmarkletCode();

        if (!this.updateScriptWindow || this.updateScriptWindow.closed) return false;

        try {
            this.updateScriptWindow.location.href = this.bookmarkletCode;
            this.focusUpdateScriptWindow(this.updateScriptWindow, false);
            return true;
        } catch { }

        try {
            const popup = window.open(this.bookmarkletCode, IIDX_EAGATE_WINDOW_NAME, IIDX_EAGATE_WINDOW_FEATURES);
            if (!popup) return false;
            this.focusUpdateScriptWindow(popup, false);
            return true;
        } catch {
            return false;
        }
    }

    public async openUpdateScriptWindow() {
        const popup = this.openEamusementSessionWindow();
        if (!popup) {
            this.updateStatusMessage = '새창이 차단되었습니다. 팝업 허용 후 다시 시도해주세요.';
            await this.service.render();
            return;
        }

        this.updateLoading = !this.updateToken;
        this.updateStatusMessage = '';
        await this.service.render();

        const ready = await this.ensureUpdateToken();
        const copied = ready ? await this.copyUpdateScriptForFallback() : false;

        this.updateLoading = false;
        await this.loadUpdateStatus(false);
        this.updateBookmarkletCode();
        this.updateStatusMessage = copied
            ? 'e-amusement 창을 열고 스크립트를 복사했습니다. 로그인 후 실행을 눌러주세요.'
            : 'e-amusement 창을 열었습니다. 로그인 후 실행을 누르거나 스크립트를 직접 복사해주세요.';
        await this.service.render();
    }

    public async runUpdateScriptInSession() {
        this.updateLoading = true;
        this.updateStatusMessage = '';
        const session = this.getUpdateSessionWindowForExecution();
        await this.service.render();

        if (!session.popup) {
            this.updateLoading = false;
            this.updateStatusMessage = '새창이 차단되었습니다. 팝업 허용 후 다시 시도해주세요.';
            await this.service.render();
            return;
        }

        if (!session.ready) {
            this.updateLoading = false;
            this.updateStatusMessage = 'e-amusement 창을 열었습니다. 로그인한 뒤 실행을 다시 눌러주세요.';
            await this.service.render();
            return;
        }

        const ready = await this.ensureUpdateToken();
        if (!ready) {
            this.updateLoading = false;
            await this.service.render();
            return;
        }

        const copied = await this.copyUpdateScriptForFallback();
        const requested = this.requestUpdateScriptExecution();

        this.updateLoading = false;
        if (requested) {
            this.updateStatusMessage = copied
                ? '자동 실행 요청을 보냈고 스크립트도 복사했습니다. e-amusement 창에 변화가 없으면 주소창에 붙여넣고 Enter를 눌러주세요.'
                : '자동 실행 요청을 보냈습니다. e-amusement 창에 변화가 없으면 스크립트 칸을 직접 복사해주세요.';
            this.startUpdateStatusPolling();
        } else {
            this.updateStatusMessage = copied
                ? '브라우저가 자동 실행을 차단했습니다. 복사된 스크립트를 e-amusement 창 주소창에 붙여넣어 실행해주세요.'
                : '브라우저가 자동 실행과 복사를 차단했습니다. 스크립트 칸을 직접 복사해주세요.';
        }
        window.setTimeout(() => {
            try {
                window.focus();
            } catch { }
        }, 120);
        await this.service.render();
    }

    private latestUpdatedMillis(): number {
        const latest = this.updateInfo && this.updateInfo.latest;
        const value = latest && (latest.updated || latest.createAt);
        if (!value) return 0;
        const millis = new Date(value).getTime();
        return Number.isNaN(millis) ? 0 : millis;
    }

    private stopUpdateStatusPolling() {
        if (this.updatePollTimer) {
            window.clearInterval(this.updatePollTimer);
            this.updatePollTimer = null;
        }
        this.updatePollStartedAt = 0;
    }

    private startUpdateStatusPolling() {
        this.stopUpdateStatusPolling();
        this.updatePollStartedAt = Date.now();
        this.updatePollTimer = window.setInterval(async () => {
            if (Date.now() - this.updatePollStartedAt > UPDATE_POLL_TIMEOUT_MS) {
                this.stopUpdateStatusPolling();
                return;
            }
            await this.pollUpdateStatus();
        }, UPDATE_POLL_INTERVAL_MS);
    }

    private async pollUpdateStatus() {
        const before = this.latestUpdatedMillis();
        await this.loadUpdateStatus(false, false, false);
        const after = this.latestUpdatedMillis();
        if (after > Math.max(before, this.updateBaselineUpdatedAt)) {
            this.stopUpdateStatusPolling();
            await this.loadWeeklyRecommendations(false, true);
            this.refreshView();
            this.updateStatusMessage = '업데이트 저장 완료. 서열표 데이터를 다시 불러왔습니다.';
            await this.service.render();
        }
    }

    private async invalidateIidxTierCacheAndRefetch(showMessage: boolean = false) {
        this.latestScoreMap = {};
        console.info('[iidx-tier] invalidate/refetch', { scope: '/iidx/tier', freshWeekly: true });
        await this.loadUpdateStatus(false, true);
        this.refreshView();
        if (showMessage) {
            this.updateStatusMessage = this.latestDataIssue || '최신 데이터를 불러왔습니다.';
        }
        await this.service.render();
    }

    public async generateUpdateToken() {
        this.updateLoading = true;
        this.updateStatusMessage = '';
        await this.service.render();

        await this.requestUpdateToken();

        this.updateLoading = false;
        await this.loadUpdateStatus(false);
        this.updateBookmarkletCode();
        await this.service.render();
    }

    public async loadUpdateStatus(showMessage: boolean = true, freshWeekly: boolean = false, syncWeekly: boolean = true) {
        this.refreshLoading = showMessage;
        if (showMessage) await this.service.render();

        try {
            const playStyle = this.getLatestScorePlayStyle();
            const scoreLevel = this.getLatestScoreLevelFilter(playStyle);
            const params: any = { playStyle, _ts: Date.now(), fresh: freshWeekly ? '1' : '0' };
            if (scoreLevel > 0) params.level = scoreLevel;
            const { code, data } = await wiz.call("load_update_status", params);
            if (code === 200 && data) {
                this.updateInfo = data;
                this.applyLatestProfile(data.latest);
                if (syncWeekly) await this.loadWeeklyRecommendations(false, freshWeekly);
                this.latestDataIssue = this.getLatestDataIssue(data.latest);
                console.info('[iidx-tier] update status loaded', {
                    userId: data.latest && data.latest.userId,
                    iidxId: data.latest && data.latest.iidxId,
                    djName: data.latest && data.latest.djName,
                    scoreCount: data.latest && data.latest.scoreCount,
                    latestDataIssue: this.latestDataIssue,
                    freshWeekly,
                    syncWeekly
                });
                if (showMessage) this.updateStatusMessage = this.latestDataIssue || '최신 데이터를 불러왔습니다.';
            } else if (showMessage) {
                this.updateStatusMessage = data?.message || '최신 데이터 확인에 실패했습니다.';
            }
        } catch {
            if (showMessage) this.updateStatusMessage = '최신 데이터 확인에 실패했습니다.';
        }

        this.refreshLoading = false;
        await this.service.render();
    }

    public async logout() {
        try {
            await wiz.call("logout");
        } catch { }

        this.stopUpdateStatusPolling();
        this.updateInfo = { loggedIn: false, latest: null, user: null };
        this.updateToken = '';
        this.updateTokenExpires = '';
        this.updateStatusMessage = '';
        await this.loadUpdateStatus(false, true);
        this.updateBookmarkletCode();
        await this.service.render();
    }

    public getIidxAccountLabel(): string {
        const user = this.updateInfo && this.updateInfo.user || {};
        const latest = this.updateInfo && this.updateInfo.latest || {};
        return user.name || user.email || latest.djName || '사용자';
    }

    public async refreshLatestProfile() {
        await this.invalidateIidxTierCacheAndRefetch(true);
    }

    private getLatestScorePlayStyle(): PlayStyle {
        return this.tablePlayStyle === 'DP' || this.selectedPlayStyle === 'DP' ? 'DP' : 'SP';
    }

    private getLatestScoreLevelFilter(playStyle: PlayStyle = this.getLatestScorePlayStyle()): number {
        if (this.isDanModeSelected()) return 0;
        return playStyle === 'SP' ? 12 : 0;
    }

    private getLatestScoreScopeLabel(playStyle: PlayStyle = this.getLatestScorePlayStyle()): string {
        const level = this.getLatestScoreLevelFilter(playStyle);
        return level > 0 ? `${playStyle} ${level}레벨` : playStyle;
    }

    private normalizePlayType(value: any, fallback: PlayStyle = 'SP'): PlayStyle {
        const text = String(value || fallback || 'SP').trim().toUpperCase();
        return text.includes('DP') || text.includes('DOUBLE') ? 'DP' : 'SP';
    }

    private normalizeScoreRecord(record: any, fallbackPlayStyle: PlayStyle) {
        const playType = this.normalizePlayType(record && (record.play_type || record.playType), fallbackPlayStyle);
        const musicKey = this.normalizeStoredMusicKey(record && (record.music_key || record.musicKey));
        return {
            ...record,
            music_name: record && (record.music_name || record.musicName || record.title || ''),
            music_key: musicKey,
            musicKey,
            difficulty: this.normalizeScoreDifficulty(record && record.difficulty),
            level: Number(record && record.level || 0),
            clear_type: record && (record.clear_type || record.clearType || ''),
            score: Number(record && record.score || 0),
            play_type: playType
        };
    }

    private applyLatestProfile(profile: any) {
        const playStyle = this.getLatestScorePlayStyle();
        if (!profile || !profile.musicData) {
            this.latestScoreMap = this.loadLocalIidxScoreMap(playStyle);
            this.latestDataIssue = this.getLatestDataIssue(profile);
            this.refreshView();
            return;
        }

        this.latestScoreMap = {};
        const scores = Array.isArray(profile.musicData[playStyle]) ? profile.musicData[playStyle] : [];
        for (const record of scores) {
            const normalized = this.normalizeScoreRecord(record, playStyle);
            for (const key of this.makeRecordScoreKeys(normalized)) {
                this.latestScoreMap[key] = normalized;
            }
        }
        this.latestDataIssue = this.getLatestDataIssue(profile);
        this.refreshView();
    }

    private hasMatchingProfileRows(rows: any[]): boolean {
        if (!this.songs.length || !Array.isArray(rows) || !rows.length) return false;
        const songKeys: any = {};
        for (const song of this.songs) {
            for (const key of this.makeScoreKeys(song && song.title, song && song.difficulty)) {
                songKeys[key] = true;
            }
        }
        return rows.some((record) => {
            const normalized = this.normalizeScoreRecord(record, this.tablePlayStyle);
            return this.makeRecordScoreKeys(normalized).some((key) => !!songKeys[key]);
        });
    }

    private getLatestDataIssue(profile: any): string {
        if (!this.updateInfo || !this.updateInfo.loggedIn) {
            return '로그인이 필요합니다.';
        }
        if (!profile) {
            return 'DB에 저장된 IIDX 프로필이 없습니다. 토큰 업데이트 완료 여부와 서버 submit 로그를 확인하세요.';
        }
        if (!profile.userId) {
            return '저장 프로필에 userId가 없습니다. 토큰 사용자와 조회 사용자가 같은지 확인하세요.';
        }
        const playStyle = this.getLatestScorePlayStyle();
        const scopeLabel = this.getLatestScoreScopeLabel(playStyle);
        const scoreCount = Number(profile.scoreCount && profile.scoreCount[playStyle] || 0);
        const rows = profile.musicData && Array.isArray(profile.musicData[playStyle]) ? profile.musicData[playStyle] : [];
        if (scoreCount <= 0) {
            return `${playStyle} 스코어가 0곡입니다. 서버는 프로필을 찾았지만 musicData.${playStyle} 저장 결과가 비어 있습니다.`;
        }
        if (rows.length <= 0) {
            return `${scopeLabel} 기록이 0곡입니다. 전체 ${playStyle} 저장 기록은 ${scoreCount}곡이지만 현재 서열표 범위에는 없습니다.`;
        }
        if (this.songs.length && !this.hasMatchingProfileRows(rows)) {
            return `${scopeLabel} ${rows.length}곡이 DB에 있으나 서열표 곡명/난이도 키와 매칭되지 않습니다. music_name 또는 difficulty 정규화를 확인하세요.`;
        }
        return '';
    }

    private normalizeWeeklyRecommendation(item: any, index: number) {
        const title = String(item && item.title || '').trim();
        const difficulty = String(item && item.difficulty || 'UNKNOWN').trim();
        const songKey = item && item.songKey ? item.songKey : `weekly-${index}-${title}-${difficulty}`;
        const bpmInfo = this.getSongBpmInfo(item || {});
        return {
            ...item,
            songKey,
            title,
            difficulty,
            level: Number(item && item.level || this.weeklyLevel || 12),
            playStyle: this.normalizePlayType(item && item.playStyle, this.tablePlayStyle),
            bpm: item && item.bpm || bpmInfo.bpm,
            bpmBand: item && item.bpmBand || bpmInfo.band,
            primaryTag: this.normalizePrimaryTag(item && item.primaryTag),
            secondaryTags: this.normalizeSecondaryTags(item && item.secondaryTags),
            record: item && item.record || null,
            weeklyReasons: Array.isArray(item && item.weeklyReasons) ? item.weeklyReasons : []
        };
    }

    private applyWeeklySnapshot(data: any) {
        this.weeklyKey = data?.weeklyKey || data?.weekKey || this.weeklyKey;
        this.weeklyRangeLabel = data?.weeklyRangeLabel || data?.label || this.weeklyRangeLabel;
        this.weeklyLevel = Number(data?.level || this.weeklyLevel || 12);
        this.weeklyLocked = !!data?.locked;
        this.weeklyNextRefreshAt = data?.nextRefreshAt || '';
        const rows = Array.isArray(data?.recommendations) ? data.recommendations : [];
        this.weeklyRecommendations = rows.map((item: any, index: number) => this.normalizeWeeklyRecommendation(item, index));
    }

    private async loadWeeklyRecommendations(render: boolean = true, fresh: boolean = false) {
        try {
            const playStyle = this.tablePlayStyle === 'DP' ? 'DP' : 'SP';
            const { code, data } = await wiz.call("load_weekly_recommendations", { playStyle, fresh: fresh ? '1' : '0', _ts: Date.now() });
            if (code === 200 && data) {
                this.applyWeeklySnapshot(data);
            }
        } catch { }

        if (render) await this.service.render();
    }

    private foldScoreTitleText(title: any): string {
        let text = String(title || '').normalize('NFKD');
        const replacements: Array<[RegExp, string]> = [
            [/[\u2020\u2021]/g, ''],
            [/[\u00f8\u00d8]/g, 'o'],
            [/\u00e6/g, 'ae'],
            [/\u00c6/g, 'AE'],
            [/\u0438/g, 'n'],
            [/\u0418/g, 'N'],
            [/\u04d9/g, 'e'],
            [/\u04d8/g, 'E'],
            [/\u0131/g, 'i'],
            [/\u01b5/g, 'Z'],
            [/\u01b6/g, 'z'],
            [/\ua4d8/g, 'K'],
            [/\ua4d9/g, 'E'],
            [/\u03bb/g, 'l'],
            [/\u039b/g, 'L'],
            [/\u03c7/g, 'x'],
            [/\u03a7/g, 'X'],
            [/\u03df/g, 's'],
            [/\u2200/g, 'turnedA'],
            [/\u01dd/g, 'e'],
            [/\u0259/g, 'e'],
            [/\u0192/g, 'f'],
            [/\u00df/g, 'ss'],
            [/\u3006/g, 'shime'],
            [/\u2261/g, 'equiv'],
            [/\uff0b/g, 'plus'],
            [/\+/g, 'plus'],
            [/\u7131/g, '\u706b']
        ];
        for (const [pattern, replacement] of replacements) {
            text = text.replace(pattern, replacement);
        }
        return text.replace(/[\u0300-\u036f]/g, '');
    }

    private normalizeScoreTitle(title: any): string {
        return this.foldScoreTitleText(title).toLowerCase().replace(/[\p{P}\p{S}\s]+/gu, '');
    }

    private getScoreTitleAliases(title: any): string[] {
        const normalizedTitle = this.normalizeScoreTitle(title);
        if (!normalizedTitle) return [];

        const aliases = new Set<string>([normalizedTitle]);
        const rawTitle = String(title || '');
        if (/[0Øø]/.test(rawTitle) || normalizedTitle.includes('0')) {
            aliases.add(normalizedTitle.replace(/0/g, 'o'));
            aliases.add(normalizedTitle.replace(/o/g, '0'));
        }
        return Array.from(aliases).filter((value) => !!value);
    }

    private normalizeStoredMusicKey(value: any): string {
        return this.normalizeScoreTitle(value);
    }

    private normalizeScoreDifficulty(difficulty: any): string {
        const text = String(difficulty || '').trim().toUpperCase();
        const compact = text.replace(/[^A-Z†]/g, '');
        const aliases: any = {
            N: 'NORMAL',
            SPN: 'NORMAL',
            DPN: 'NORMAL',
            NORMAL: 'NORMAL',
            H: 'HYPER',
            SPH: 'HYPER',
            DPH: 'HYPER',
            HYPER: 'HYPER',
            A: 'ANOTHER',
            SPA: 'ANOTHER',
            DPA: 'ANOTHER',
            ANOTHER: 'ANOTHER',
            L: 'LEGGENDARIA',
            SPL: 'LEGGENDARIA',
            DPL: 'LEGGENDARIA',
            LEGGENDARIA: 'LEGGENDARIA',
            LEGENDARIA: 'LEGGENDARIA'
        };
        if (aliases[compact]) return aliases[compact];
        if (text.includes('LEGGENDARIA') || text.includes('†')) return 'LEGGENDARIA';
        if (text.includes('ANOTHER')) return 'ANOTHER';
        if (text.includes('HYPER')) return 'HYPER';
        if (text.includes('NORMAL')) return 'NORMAL';
        return text;
    }

    private makeScoreKeys(title: any, difficulty: any): string[] {
        const normalizedDifficulty = this.normalizeScoreDifficulty(difficulty);
        if (!normalizedDifficulty) return [];
        return this.getScoreTitleAliases(title).map((titleKey) => `${titleKey}::${normalizedDifficulty}`);
    }

    private makeRecordScoreKeys(record: any): string[] {
        const normalizedDifficulty = this.normalizeScoreDifficulty(record && record.difficulty);
        if (!normalizedDifficulty) return [];

        const storedKey = this.normalizeStoredMusicKey(record && (record.music_key || record.musicKey));
        if (storedKey) return [`${storedKey}::${normalizedDifficulty}`];

        return this.makeScoreKeys(record && (record.music_name || record.musicName || record.title), normalizedDifficulty);
    }

    private makeScoreKey(title: any, difficulty: any): string {
        return this.makeScoreKeys(title, difficulty)[0] || '';
    }

    private buildIidxSongLookupMap(songs: any[]): any {
        const lookup: any = {};
        for (const song of songs || []) {
            const playStyle = this.normalizePlayType(song && song.playStyle, this.tablePlayStyle);
            for (const key of this.makeScoreKeys(song && song.title, song && song.difficulty)) {
                lookup[`${playStyle}::${key}`] = song;
                if (!lookup[key]) lookup[key] = song;
            }
        }
        return lookup;
    }

    private getIidxDanReferenceSong(course: any, song: any): any {
        const playStyle = this.normalizePlayType(
            song && song.playStyle || course && course.playStyle,
            this.tablePlayStyle
        );
        for (const key of this.makeScoreKeys(song && song.title, song && song.difficulty)) {
            const matched = this.iidxSongLookupMap[`${playStyle}::${key}`] || this.iidxSongLookupMap[key];
            if (matched) return matched;
        }
        return song;
    }

    public getSongRecord(song: any): any {
        for (const key of this.makeScoreKeys(song && song.title, song && song.difficulty)) {
            if (this.latestScoreMap[key]) return this.latestScoreMap[key];
        }
        return null;
    }

    public getVisibleIidxRecord(record: any): any {
        return this.hasIidxAttemptRecord(record) ? record : null;
    }

    public getVisibleSongRecord(song: any): any {
        return this.getVisibleIidxRecord(this.getSongRecord(song));
    }

    public getIidxDanSongRecord(song: any): any {
        for (const key of this.makeScoreKeys(song && song.title, song && song.difficulty)) {
            if (this.latestScoreMap[key]) return this.latestScoreMap[key];
        }
        return null;
    }

    private isIidxKiwamiDanCourse(course: any): boolean {
        const id = String(course && course.id || '').toLowerCase();
        const name = String(course && course.name || '').toLowerCase();
        return id.includes('kiwami') || name.includes('극');
    }

    private getIidxDanLampReadiness(record: any): number {
        if (!this.hasIidxAttemptRecord(record)) return 0;
        switch (this.getLampValue(record)) {
            case 6: return 1;
            case 5: return 0.9;
            case 4: return 0.76;
            case 3: return 0.46;
            case 2: return 0.34;
            case 1: return 0.22;
            default: return 0.08;
        }
    }

    private getIidxDanScoreReadiness(song: any, record: any): number {
        if (!record) return 0;
        const scoreRate = this.getScoreRate(song, record);
        if (scoreRate > 0) return this.clamp((scoreRate - 0.55) / 0.38);
        return this.clamp(this.getRankMastery(record) * 0.85);
    }

    private getIidxDanLampReadinessCap(course: any, record: any): number {
        const lamp = this.getLampValue(record);
        const order = Number(course && course.order || 0);
        const isKiwami = this.isIidxKiwamiDanCourse(course);
        if (lamp >= 6) return 1;
        if (lamp >= 5) return isKiwami ? 0.94 : 0.92;
        if (lamp >= 4) return isKiwami
            ? (order >= 11 ? 0.76 : 0.82)
            : (order >= 11 ? 0.82 : 0.86);
        if (lamp >= 3) return order >= 11 ? 0.50 : 0.60;
        if (lamp >= 2) return 0.38;
        if (lamp >= 1) return 0.28;
        return 0.12;
    }

    private getIidxDanLampFloor(course: any): number {
        const order = Number(course && course.order || 0);
        if (this.isIidxKiwamiDanCourse(course)) return order >= 11 ? 5 : 4;
        if (order >= 11) return 4;
        if (order >= 10) return 3;
        return 0;
    }

    private getIidxDanCourseThreshold(course: any): number {
        const order = Number(course && course.order || 0);
        const isKiwami = this.isIidxKiwamiDanCourse(course);

        if (isKiwami) {
            if (order >= 12) return 0.96;
            if (order >= 11) return 0.92;
            return 0.86;
        }
        if (order >= 12) return 0.90;
        if (order >= 11) return 0.82;
        if (order >= 10) return 0.74;
        if (order >= 9) return 0.64;
        return 0.56;
    }

    private getIidxDanSongThreshold(course: any): number {
        const threshold = this.getIidxDanCourseThreshold(course);
        const isKiwami = this.isIidxKiwamiDanCourse(course);
        return this.clamp(threshold - (isKiwami ? 0.08 : 0.12), 0.48, 0.88);
    }

    private getIidxDanSongReadiness(course: any, song: any): number {
        const record = this.getIidxDanSongRecord(song);
        if (!this.hasIidxAttemptRecord(record)) return 0;
        const referenceSong = this.getIidxDanReferenceSong(course, song);
        const lampReadiness = this.getIidxDanLampReadiness(record);
        const scoreReadiness = this.getIidxDanScoreReadiness(referenceSong, record);
        const readiness = this.clamp(
            (lampReadiness * IIDX_DAN_LAMP_WEIGHT) + (scoreReadiness * IIDX_DAN_SCORE_WEIGHT)
        );
        return Math.min(readiness, this.getIidxDanLampReadinessCap(course, record));
    }

    private getIidxDanGroupKey(song: any): string {
        return String(song && song.courseLabel || '').trim() || '__single__';
    }

    private getIidxDanGroupReadinessValues(songReadiness: any[]) {
        const groups: any = {};
        for (const item of songReadiness) {
            const key = this.getIidxDanGroupKey(item.song);
            if (!groups[key]) groups[key] = [];
            groups[key].push(item.readiness);
        }

        return Object.values(groups).map((values: any) => {
            const scores = Array.isArray(values) ? values : [];
            const average = this.average(scores);
            const weakest = scores.length ? Math.min(...scores) : 0;
            return (average * 0.72) + (weakest * 0.28);
        });
    }

    private summarizeIidxDanReadiness(course: any, songReadiness: any[]) {
        const groupValues = this.getIidxDanGroupReadinessValues(songReadiness);
        if (!groupValues.length) return 0;
        const grouped = groupValues.length > 1 ? Math.min(...groupValues) : groupValues[0];
        const courseAverage = this.average(songReadiness.map((item: any) => item.readiness));
        return this.clamp((grouped * 0.82) + (courseAverage * 0.18));
    }

    public isIidxDanSongSatisfied(course: any, song: any): boolean {
        return this.getIidxDanSongReadiness(course, song) >= this.getIidxDanSongThreshold(course);
    }

    public getIidxDanCourseStats(course: any) {
        const songs = Array.isArray(course?.songs) ? course.songs : [];
        const songThreshold = this.getIidxDanSongThreshold(course);
        const courseThreshold = this.getIidxDanCourseThreshold(course);
        const songReadiness = songs.map((song: any) => ({
            song,
            readiness: this.getIidxDanSongReadiness(course, song),
            lampValue: this.getLampValue(this.getIidxDanSongRecord(song))
        }));
        const satisfied = songReadiness.filter((item: any) => item.readiness >= songThreshold).length;
        const readiness = this.summarizeIidxDanReadiness(course, songReadiness);
        const weakest = songReadiness.length
            ? Math.min(...songReadiness.map((item: any) => item.readiness))
            : 0;
        const groupValues = this.getIidxDanGroupReadinessValues(songReadiness);
        const weakestGroup = groupValues.length ? Math.min(...groupValues) : 0;
        const groupPassed = !this.isIidxKiwamiDanCourse(course) || weakestGroup >= courseThreshold;
        const lampFloor = this.getIidxDanLampFloor(course);
        const lampFloorSatisfied = lampFloor <= 0
            ? songs.length
            : songReadiness.filter((item: any) => item.lampValue >= lampFloor).length;
        const lampFloorPassed = lampFloor <= 0 || (songs.length > 0 && lampFloorSatisfied === songs.length);
        return {
            total: songs.length,
            satisfied,
            remaining: Math.max(0, songs.length - satisfied),
            readiness,
            readinessPercent: Math.round(readiness * 100),
            thresholdPercent: Math.round(courseThreshold * 100),
            songThresholdPercent: Math.round(songThreshold * 100),
            weakestPercent: Math.round(weakest * 100),
            weakestGroupPercent: Math.round(weakestGroup * 100),
            lampFloor,
            lampFloorSatisfied,
            lampFloorPassed,
            groupPassed,
            passed: songs.length > 0
                && readiness >= courseThreshold
                && weakest >= songThreshold
                && groupPassed
                && lampFloorPassed
        };
    }

    public getIidxDanCriteriaText(course: any): string {
        const fallback = '과제곡별 램프와 스코어를 보수적으로 환산해 준비도를 표시합니다.';
        return String(course?.criteria?.description || fallback).trim();
    }

    public getIidxDanStatusLabel(course: any): string {
        const stats = this.getIidxDanCourseStats(course);
        if (stats.passed) return `도전권 ${stats.readinessPercent}%`;
        if (stats.readinessPercent > 0) return `준비도 ${stats.readinessPercent}%`;
        return '미확인';
    }

    public getIidxDanSongStatusLabel(course: any, song: any): string {
        return `${Math.round(this.getIidxDanSongReadiness(course, song) * 100)}%`;
    }

    public getIidxDanRecordLabel(song: any): string {
        const record = this.getIidxDanSongRecord(song);
        if (!this.hasIidxAttemptRecord(record)) return '기록 없음';
        const clearLabel = this.getExportClearLabel(record) || 'PLAY';
        const scoreLabel = this.formatIidxScore(song, record);
        return scoreLabel && scoreLabel !== '-' ? `${clearLabel} · ${scoreLabel}` : clearLabel;
    }

    public getIidxDanDifficultyLabel(song: any): string {
        const playStyle = song && song.playStyle || this.tablePlayStyle;
        return `${playStyle} ${this.getDifficultyFilterLabel(song && song.difficulty)}`;
    }

    private iidxScoreBorder(maxScore: number, numerator: number): number {
        return Math.ceil(maxScore * numerator / 9);
    }

    private iidxScoreMidpoint(maxScore: number, numerator: number): number {
        return Math.ceil(maxScore * (numerator * 2 + 1) / 18);
    }

    private formatScoreDelta(label: string, delta: number): string {
        if (label === 'MAX' && delta === 0) return label;
        return `${label}${delta >= 0 ? '+' : '-'}${Math.abs(delta)}`;
    }

    private normalizeIidxScoreValue(score: any, noteCount: number): number {
        const raw = String(score || '');
        const direct = Number(score || 0);
        let value = Number.isFinite(direct) ? direct : 0;
        if (!value) {
            const match = raw.match(/\d[\d,]*/);
            value = match ? Number(match[0].replace(/,/g, '')) : 0;
        }
        const maxScore = noteCount > 0 ? noteCount * 2 : 0;
        if (value > 0 && maxScore > 0 && value > maxScore) {
            const digits = raw.replace(/\D/g, '');
            const maxLength = Math.min(String(maxScore).length, digits.length);
            for (let length = maxLength; length >= 1; length--) {
                const candidate = Number(digits.slice(0, length));
                if (candidate > 0 && candidate <= maxScore) return candidate;
            }
        }
        return value;
    }

    private formatIidxScoreGradeDelta(score: number, noteCount: number): string {
        const maxScore = noteCount * 2;
        if (maxScore <= 0) return '';
        if (score >= maxScore) return 'MAX';

        const levels = [
            { label: 'F', numerator: 0, threshold: 0 },
            { label: 'E', numerator: 2, threshold: this.iidxScoreBorder(maxScore, 2) },
            { label: 'D', numerator: 3, threshold: this.iidxScoreBorder(maxScore, 3) },
            { label: 'C', numerator: 4, threshold: this.iidxScoreBorder(maxScore, 4) },
            { label: 'B', numerator: 5, threshold: this.iidxScoreBorder(maxScore, 5) },
            { label: 'A', numerator: 6, threshold: this.iidxScoreBorder(maxScore, 6) },
            { label: 'AA', numerator: 7, threshold: this.iidxScoreBorder(maxScore, 7) },
            { label: 'AAA', numerator: 8, threshold: this.iidxScoreBorder(maxScore, 8) },
            { label: 'MAX', numerator: 9, threshold: maxScore }
        ];

        let index = 0;
        for (let i = levels.length - 1; i >= 0; i--) {
            if (score >= levels[i].threshold) {
                index = i;
                break;
            }
        }

        const current = levels[index];
        const next = levels[index + 1];
        if (next && next.label === 'MAX') {
            const midpoint = current.label === 'F'
                ? this.iidxScoreMidpoint(maxScore, 1)
                : this.iidxScoreMidpoint(maxScore, current.numerator);
            if (score >= midpoint) {
                return this.formatScoreDelta(next.label, score - next.threshold);
            }
        }
        return this.formatScoreDelta(current.label, score - current.threshold);
    }

    public formatIidxScore(song: any, record: any = null): string {
        const source = record || song || {};
        const noteCount = Number((song && song.noteCount) || source.noteCount || 0);
        const value = this.normalizeIidxScoreValue(source.score, noteCount);
        const rank = this.getNormalizedRankLabel(source.rank);
        if (!value) return rank || '-';
        if (noteCount > 0) {
            return this.formatIidxScoreGradeDelta(value, noteCount);
        }
        return rank || value.toLocaleString();
    }

    private getNormalizedRankLabel(rank: any): string {
        const value = String(rank || '').replace(/^rank_?/i, '').replace(/^sc_/i, '').toUpperCase();
        return value;
    }

    public getRankLabel(rank: any): string {
        return this.getNormalizedRankLabel(rank) || '-';
    }

    public shouldShowIidxRankLabel(song: any, record: any = null): boolean {
        const source = record || song || {};
        const rank = this.getNormalizedRankLabel(source.rank);
        if (!rank) return false;

        const noteCount = Number((song && song.noteCount) || source.noteCount || 0);
        const scoreValue = this.normalizeIidxScoreValue(source.score, noteCount);
        if (scoreValue > 0 && noteCount > 0) return false;

        const scoreLabel = String(this.formatIidxScore(song, record) || '').trim().toUpperCase();
        return scoreLabel !== rank && !scoreLabel.startsWith(`${rank}+`) && !scoreLabel.startsWith(`${rank}-`);
    }

    public getClearTypeLabel(clearType: any): string {
        const value = String(clearType || '').trim();
        return value;
    }

    public getClearTypeClass(clearType: any): string {
        const normalized = String(clearType || 'no-play').toLowerCase().replace(/[^a-z0-9]+/g, '-');
        return `iidx-clear-badge clear-${normalized || 'no-play'}`;
    }

    private getNormalizedClearType(record: any): string {
        return String(record && (record.clear_type || record.clearType) || '')
            .trim()
            .toUpperCase()
            .replace(/[_\s]+/g, '-');
    }

    private isNoPlayClearType(value: any): boolean {
        const normalized = String(value || '').trim().toUpperCase().replace(/[_\s]+/g, '-');
        return !normalized || normalized.includes('NO-PLAY') || normalized.includes('NOPLAY');
    }

    private hasIidxAttemptRecord(record: any): boolean {
        if (!record) return false;
        const clearType = this.getNormalizedClearType(record);
        if (clearType && !this.isNoPlayClearType(clearType)) return true;
        const score = this.normalizeIidxScoreValue(record.score, Number(record.noteCount || 0));
        if (score > 0) return true;
        return !!this.getNormalizedRankLabel(record.rank);
    }

    public shouldShowLampLine(record: any): boolean {
        return this.hasIidxAttemptRecord(record);
    }

    public getLampLineClass(record: any): string {
        const classes = [
            'lamp-failed',
            'lamp-assist',
            'lamp-easy',
            'lamp-normal',
            'lamp-hard',
            'lamp-ex-hard',
            'lamp-full-combo'
        ];
        const value = this.getLampValue(record);
        if (!this.hasIidxAttemptRecord(record)) return 'iidx-lamp-line lamp-none';
        return `iidx-lamp-line ${classes[value] || classes[0]}`;
    }

    public getPrimaryTag(song: any): string {
        return this.normalizePrimaryTag(song && song.primaryTag);
    }

    private getSongTags(song: any): string[] {
        const tags = [this.getPrimaryTag(song), ...this.normalizeSecondaryTags(song && song.secondaryTags)];
        const seen: any = {};
        return tags.filter((tag) => {
            if (!tag || seen[tag]) return false;
            seen[tag] = true;
            return true;
        });
    }

    private getWeeklyInfo() {
        const now = new Date();
        const date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
        const day = date.getUTCDay() || 7;
        date.setUTCDate(date.getUTCDate() + 4 - day);
        const year = date.getUTCFullYear();
        const yearStart = new Date(Date.UTC(year, 0, 1));
        const week = Math.ceil((((date.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
        return {
            key: `${year}-W${week}`,
            label: `${year}년 ${week}주차`
        };
    }

    private hashString(value: string): number {
        let hash = 2166136261;
        for (let i = 0; i < value.length; i++) {
            hash ^= value.charCodeAt(i);
            hash = Math.imul(hash, 16777619);
        }
        return hash >>> 0;
    }

    private seededUnit(value: string): number {
        return this.hashString(value) / 4294967295;
    }

    private getWeeklyLevel(): number {
        if (this.isDirectTierMode()) {
            const selectedLevels = this.getSelectedDirectLevels();
            if (selectedLevels.length) return Math.max(...selectedLevels);
        }

        if (this.selectedLevel !== 'all') {
            const selected = Number(this.selectedLevel);
            if (!Number.isNaN(selected)) return selected;
        }
        if (this.levels.length) return Math.max(...this.levels.map((level) => Number(level)).filter((level) => !Number.isNaN(level)));
        return 12;
    }

    public getWeeklyLevelLabel(): string {
        return `☆${this.weeklyLevel}`;
    }

    private getTierDifficultyValue(tier: any): number {
        const tierText = String(tier || '').trim();
        const numeric = Number(tierText);
        if (!Number.isNaN(numeric)) return numeric;
        const order: any = {
            'F': 1,
            'E': 2,
            'D': 3,
            'C': 4,
            'B': 5,
            'B+': 6,
            'A': 7,
            'A+': 8,
            'S': 9,
            'S+': 10
        };
        return order[tierText] || 0;
    }

    private getClearMastery(record: any): number {
        if (!this.hasIidxAttemptRecord(record)) return 0;
        return this.getLampValue(record) / 6;
    }

    private getLampValue(record: any): number {
        if (!this.hasIidxAttemptRecord(record)) return 0;
        const value = this.getNormalizedClearType(record);
        if (this.isNoPlayClearType(value) || value.includes('FAILED') || value.includes('FAIL')) return 0;
        if (value.includes('F-COMBO') || value.includes('FULL-COMBO') || value.includes('FULLCOMBO')) return 6;
        if (value.includes('EXH') || value.includes('EX-HARD') || value.includes('EX-H-CLEAR')) return 5;
        if (value.includes('H-CLEAR') || value.includes('HARD')) return 4;
        if (value.includes('A-CLEAR') || value.includes('ASSIST')) return 1;
        if (value.includes('E-CLEAR') || value.includes('EASY')) return 2;
        if (value.includes('CLEAR') || value.includes('NORMAL')) return 3;
        return 0;
    }

    private getLampSortValue(record: any): number {
        return this.hasIidxAttemptRecord(record) ? this.getLampValue(record) : -1;
    }

    private getScoreRate(song: any, record: any): number {
        const noteCount = Number(song && song.noteCount || 0);
        const score = this.normalizeIidxScoreValue(record && record.score, noteCount);
        if (score <= 0) return 0;
        if (noteCount > 0) {
            return Math.max(0, Math.min(1, score / (noteCount * 2)));
        }
        return this.getRankMastery(record);
    }

    private getSongScoreSortValue(song: any): number {
        const record = this.getSongRecord(song);
        const noteCount = Number(song && song.noteCount || record && record.noteCount || 0);
        const score = this.normalizeIidxScoreValue(record && record.score, noteCount);
        if (score <= 0) return Number.MIN_SAFE_INTEGER;
        const maxScore = noteCount > 0 ? noteCount * 2 : 0;
        if (maxScore > 0) return score - maxScore;
        return score;
    }

    private getRankMastery(record: any): number {
        const rank = this.getRankLabel(record && record.rank);
        switch (rank) {
            case 'MAX': return 1.00;
            case 'AAA': return 0.94;
            case 'AA': return 0.82;
            case 'A': return 0.66;
            case 'B': return 0.50;
            case 'C': return 0.34;
            case 'D': return 0.20;
            case 'E':
            case 'F': return 0.10;
            default: return 0;
        }
    }

    private getSongMastery(song: any): number {
        const record = this.getSongRecord(song);
        if (!this.hasIidxAttemptRecord(record)) return 0;
        return Math.max(this.getClearMastery(record), this.getRankMastery(record) * 0.85);
    }

    private parseBpmValue(value: any): number | null {
        if (typeof value === 'number' && isFinite(value)) return value;
        if (typeof value === 'string') {
            const match = value.match(/\d+(\.\d+)?/);
            if (match) return parseFloat(match[0]);
        }
        return null;
    }

    private formatBpmNumber(value: any): string {
        if (value === null || value === undefined || value === '') return '';
        const numeric = typeof value === 'number' ? value : Number(value);
        if (!Number.isFinite(numeric)) return '';
        const rounded = Math.round(numeric * 10) / 10;
        return Number.isInteger(rounded) ? String(rounded) : String(rounded).replace(/\.0$/, '');
    }

    private formatBpmText(value: any): string {
        const text = String(value || '').trim();
        if (!text || text.toLowerCase() === 'nan') return '';
        const normalized = text.replace(/[~〜～–—－]/g, '-');
        const range = normalized.match(/(\d+(\.\d+)?)\s*-\s*(\d+(\.\d+)?)/);
        if (range) {
            const min = this.formatBpmNumber(range[1]);
            const max = this.formatBpmNumber(range[3]);
            return min && max ? `${min}~${max}` : '';
        }

        const bpm = this.parseBpmValue(text);
        return bpm === null ? '' : this.formatBpmNumber(bpm);
    }

    private hasBpmRangeText(value: any): boolean {
        const text = String(value || '').trim().replace(/[~〜～–—－]/g, '-');
        return /\d+(\.\d+)?\s*-\s*\d+(\.\d+)?/.test(text);
    }

    private getSongBpmInfo(song: any) {
        const bpm = this.parseBpmValue(song && song.bpm);
        const bpmMin = this.parseBpmValue(song && song.bpmMin);
        const bpmMax = this.parseBpmValue(song && song.bpmMax);
        const bpmType = song && song.bpmType || '';
        const bpmText = String(song && song.bpm || '');
        const range = bpmMin !== null && bpmMax !== null ? bpmMax - bpmMin : 0;
        let band = 'unknown';
        const baseBpm = bpm || bpmMax || bpmMin;

        if (bpmType === 'variable' || range >= 40 || this.hasBpmRangeText(bpmText)) {
            band = 'variable';
        } else if (baseBpm !== null && baseBpm !== undefined) {
            if (baseBpm <= 120) band = 'slow';
            else if (baseBpm <= 160) band = 'mid';
            else if (baseBpm <= 200) band = 'fast';
            else band = 'very-fast';
        }

        return { bpm: baseBpm, bpmMin, bpmMax, bpmType, bpmText, band };
    }

    public getBpmBandLabel(band: string): string {
        switch (band) {
            case 'variable': return '변속';
            default: return '';
        }
    }

    public getWeeklyBpmLabel(song: any): string {
        if (!song) return '';
        const bpmInfo = this.getSongBpmInfo(song);
        const band = bpmInfo.band !== 'unknown' ? bpmInfo.band : String(song.bpmBand || '');
        const bpmText = this.formatBpmText(song.bpm || bpmInfo.bpmText);
        const fallbackRange = bpmInfo.bpmMin !== null && bpmInfo.bpmMax !== null
            ? `${this.formatBpmNumber(bpmInfo.bpmMin)}~${this.formatBpmNumber(bpmInfo.bpmMax)}`
            : '';
        const displayBpm = band === 'variable'
            ? fallbackRange || bpmText || this.formatBpmNumber(bpmInfo.bpm)
            : bpmText || fallbackRange || this.formatBpmNumber(bpmInfo.bpm);
        const label = this.getBpmBandLabel(band);

        if (label) return displayBpm ? `${label} ${displayBpm} BPM` : label;
        return displayBpm ? `${displayBpm} BPM` : '';
    }

    private matchesWeeklyFilters(song: any): boolean {
        if (this.selectedDifficulty !== 'all' && song.difficulty !== this.selectedDifficulty) return false;
        if (this.selectedVersion !== 'all' && song.version !== this.selectedVersion) return false;
        const text = (this.searchText || '').trim().toLowerCase();
        if (!text) return true;
        const haystack = [
            song.title,
            song.difficulty,
            song.versionLabel,
            song.level,
            song.memo,
            song.tier,
            song.epRaw,
            song.idRaw,
            song.hardRaw,
            song.normalRaw,
            song.primaryTag,
            ...(Array.isArray(song.secondaryTags) ? song.secondaryTags : [])
        ].join(' ').toLowerCase();
        return haystack.includes(text);
    }

    private clamp(value: number, min: number = 0, max: number = 1): number {
        if (!Number.isFinite(value)) return min;
        return Math.max(min, Math.min(max, value));
    }

    private average(values: number[]): number {
        const filtered = values.filter((value) => Number.isFinite(value));
        if (!filtered.length) return 0;
        return filtered.reduce((sum, value) => sum + value, 0) / filtered.length;
    }

    private median(values: number[]): number {
        const sorted = values.filter((value) => Number.isFinite(value)).sort((left, right) => left - right);
        if (!sorted.length) return 0;
        const middle = Math.floor(sorted.length / 2);
        return sorted.length % 2 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2;
    }

    private percentileRank(values: number[], value: number): number {
        const sorted = values.filter((item) => Number.isFinite(item)).sort((left, right) => left - right);
        if (!sorted.length || !Number.isFinite(value)) return 1;
        const belowOrEqual = sorted.filter((item) => item <= value).length;
        return belowOrEqual / sorted.length;
    }

    private getWeeklyGroupKey(song: any): string {
        return [
            Number(song && song.level || 0),
            this.normalizeTier(song && song.tier),
            String(song && song.difficulty || '').trim().toUpperCase()
        ].join('::');
    }

    private buildWeeklyBaselines(songs: any[]) {
        const groups: any = {};
        for (const song of songs) {
            const key = this.getWeeklyGroupKey(song);
            if (!groups[key]) groups[key] = { lampValues: [], scoreRates: [], count: 0 };
            const record = this.getSongRecord(song);
            groups[key].count += 1;
            groups[key].lampValues.push(this.getLampValue(record));
            const scoreRate = this.getScoreRate(song, record);
            if (scoreRate > 0) groups[key].scoreRates.push(scoreRate);
        }

        for (const group of Object.values(groups) as any[]) {
            group.lampBaseline = Math.max(this.average(group.lampValues), this.median(group.lampValues));
            group.scoreBaseline = Math.max(this.average(group.scoreRates), this.median(group.scoreRates));
        }
        return groups;
    }

    private evaluateWeeklySong(song: any, groups: any) {
        const record = this.getSongRecord(song);
        const group = groups[this.getWeeklyGroupKey(song)] || { lampBaseline: 0, scoreBaseline: 0, scoreRates: [], count: 1 };
        const lampValue = this.getLampValue(record);
        const lampGap = this.clamp((Number(group.lampBaseline || 0) - lampValue) / 6);
        const hardGap = lampValue < 4 ? this.clamp((4 - lampValue) / 4) : 0;
        const scoreRate = this.getScoreRate(song, record);
        const scoreGap = scoreRate > 0 ? Math.max(0, Number(group.scoreBaseline || 0) - scoreRate) : 0;
        const scorePercentile = scoreRate > 0 && group.scoreRates && group.scoreRates.length > 1
            ? this.percentileRank(group.scoreRates, scoreRate)
            : 1;
        const scoreWeakness = scoreRate > 0
            ? this.clamp(scoreGap * 4 + Math.max(0, 0.35 - scorePercentile) * 1.4)
            : 0;
        const lampWeakness = this.clamp(lampGap * 0.72 + hardGap * 0.28);

        return {
            ...song,
            record,
            mastery: this.getSongMastery(song),
            lampValue,
            lampBaseline: Number(group.lampBaseline || 0),
            lampGap,
            hardGap,
            scoreRate,
            scoreGap,
            scoreBaseline: Number(group.scoreBaseline || 0),
            scorePercentile,
            scoreWeakness,
            lampWeakness,
            groupSize: group.count || 1
        };
    }

    private buildWeakTagScores(evaluatedSongs: any[]) {
        if (!evaluatedSongs.some((song) => this.hasIidxAttemptRecord(song.record))) return {};

        const stats: any = {};
        for (const song of evaluatedSongs) {
            const weakness = song.lampWeakness * 0.58 + song.scoreWeakness * 0.42;
            if (weakness < 0.08) continue;
            for (const tag of this.getSongTags(song)) {
                if (!stats[tag]) stats[tag] = { total: 0, count: 0, worst: 0 };
                stats[tag].total += weakness;
                stats[tag].count += 1;
                stats[tag].worst = Math.max(stats[tag].worst, weakness);
            }
        }

        const ranked = Object.keys(stats)
            .map((tag) => ({
                tag,
                score: stats[tag].total / Math.max(1, stats[tag].count) * 0.75 + stats[tag].worst * 0.25
            }))
            .filter((item) => item.score >= 0.12)
            .sort((left, right) => right.score - left.score)
            .slice(0, 4);

        const result: any = {};
        for (const item of ranked) result[item.tag] = item.score;
        return result;
    }

    private getWeakTagScore(song: any, weakTagScores: any) {
        let tag = '';
        let score = 0;
        for (const candidate of this.getSongTags(song)) {
            const value = Number(weakTagScores[candidate] || 0);
            if (value > score) {
                tag = candidate;
                score = value;
            }
        }
        return { tag, score };
    }

    private buildWeeklyReasons(song: any, weakTagScores: any): string[] {
        const reasons: string[] = [];
        const weakTag = this.getWeakTagScore(song, weakTagScores);
        if (weakTag.score >= 0.12 && weakTag.tag) reasons.push(`${weakTag.tag} 약점`);
        if (!this.hasIidxAttemptRecord(song.record)) reasons.push('미플레이');
        if (song.lampValue < 4) reasons.push('하드 미달성');
        else if (song.lampGap >= 0.16) reasons.push('동티어 대비 램프 낮음');
        if (song.scoreWeakness >= 0.18 || song.scoreGap >= 0.04 || song.scorePercentile <= 0.35) {
            reasons.push('동레벨 대비 점수 낮음');
        }
        if (!reasons.length) reasons.push(song.lampValue < 5 ? '익스하드 미달성' : '주간 보완곡');
        return reasons.slice(0, 3);
    }

    private selectWeeklyRecommendations(candidates: any[], weakTagScores: any): any[] {
        const selected: any[] = [];
        const selectedKeys: any = {};
        const weakTags = Object.keys(weakTagScores)
            .sort((left, right) => Number(weakTagScores[right] || 0) - Number(weakTagScores[left] || 0));

        for (const tag of weakTags.slice(0, 3)) {
            const pick = candidates.find((song) => this.getSongTags(song).includes(tag) && !selectedKeys[song.songKey]);
            if (!pick) continue;
            selected.push(pick);
            selectedKeys[pick.songKey] = true;
        }

        for (const song of candidates) {
            if (selected.length >= 6) break;
            if (selectedKeys[song.songKey]) continue;
            selected.push(song);
            selectedKeys[song.songKey] = true;
        }

        return selected.slice(0, 6);
    }

    private updateWeeklyRecommendations() {
        const weeklyInfo = this.getWeeklyInfo();
        if (!this.weeklyKey) this.weeklyKey = weeklyInfo.key;
        if (!this.weeklyRangeLabel) this.weeklyRangeLabel = weeklyInfo.label;
        if (!this.weeklyLevel) this.weeklyLevel = this.getWeeklyLevel();
    }

    public getWeeklyReason(song: any): string {
        if (!song) return '';
        if (Array.isArray(song.weeklyReasons) && song.weeklyReasons.length) {
            return song.weeklyReasons.join(' · ');
        }
        return '주간 보완곡';
    }

    public getLatestUpdatedText(): string {
        const latest = this.updateInfo && this.updateInfo.latest;
        const value = latest && (latest.updated || latest.createAt);
        if (!value) return '없음';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value);
        return date.toLocaleString('ko-KR');
    }

    public getLatestProfileText(): string {
        const latest = this.updateInfo && this.updateInfo.latest;
        if (!latest) return '저장된 데이터 없음';
        const name = latest.djName || 'DJ NAME 없음';
        const iidxId = latest.iidxId ? ` / ${latest.iidxId}` : '';
        const playStyle = this.tablePlayStyle === 'DP' ? 'DP' : 'SP';
        const scoreCount = latest.scoreCount && latest.scoreCount[playStyle] ? latest.scoreCount[playStyle] : 0;
        return `${name}${iidxId} / ${playStyle} ${scoreCount}곡`;
    }

    public getPlayStyleLabel(): string {
        return this.tablePlayStyle === 'DP' ? 'DP' : 'SP';
    }

    private writeClipboardTextFallback(text: string): boolean {
        const activeElement = document.activeElement as HTMLElement | null;
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '0';
        textarea.style.left = '0';
        textarea.style.width = '1px';
        textarea.style.height = '1px';
        textarea.style.opacity = '0';
        textarea.style.pointerEvents = 'none';

        try {
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            textarea.setSelectionRange(0, textarea.value.length);
            return document.execCommand('copy');
        } catch {
            return false;
        } finally {
            textarea.remove();
            try {
                if (activeElement && activeElement.focus) activeElement.focus();
            } catch { }
        }
    }

    private async writeClipboardText(text: string): Promise<boolean> {
        if (!text) return false;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(text);
                return true;
            } catch {
                return this.writeClipboardTextFallback(text);
            }
        }
        return this.writeClipboardTextFallback(text);
    }

    private markCopiedTarget(target: string) {
        this.copiedTarget = target;
        window.setTimeout(async () => {
            if (this.copiedTarget === target) {
                this.copiedTarget = '';
                await this.service.render();
            }
        }, 1400);
    }

    public async copyText(text: string, target: string) {
        const copied = await this.writeClipboardText(text);
        if (copied) {
            this.markCopiedTarget(target);
        } else {
            this.updateStatusMessage = target === 'bookmarklet'
                ? '복사에 실패했습니다. 스크립트 칸을 전체 선택해 직접 복사해주세요.'
                : '복사에 실패했습니다.';
        }
        await this.service.render();
    }

    public selectElementText(event: Event) {
        const target = event.target as HTMLInputElement | HTMLTextAreaElement | null;
        if (target && typeof target.select === 'function') target.select();
    }

    public trackSong(index: number, song: any) {
        if (!song) return index;
        return [
            song.songKey || song.id || '',
            song.title || '',
            song.difficulty || '',
            song.version || '',
            song.playStyle || this.tablePlayStyle || ''
        ].join('::') || index;
    }

    public trackSection(index: number, section: any) {
        return section.id || section.name || index;
    }

    public trackTab(index: number, tab: TableTab) {
        return tab.value || index;
    }

}

export default PageIidxComponent;